import logo from './logo.svg';
import './App.css';

import React from 'react'
import react, { useState, useRef, useEffect} from 'react';
import { Container, Accordion, Card, Button, Navbar, Nav, NavDropdown, Form, FormControl, Dropdown } from "react-bootstrap";
import Question from './Question';
import QuestionAvecExclusion from './QuestionAvecExclusion';

import Boutonexcluinput from './Boutonexcluinput';
import Boutonexclu from './Boutonexclu';

import NvxBandeauINES from './image/NextStage.jpeg';

// IMPORT PHOTO LETTRE
import LA from './image/LA.PNG';
import LB from './image/LB.PNG';
import LC from './image/LC.PNG';
import LD from './image/LD.PNG';
import LE from './image/LE.PNG';


import firestore from "./firestore";
import firebase from "firebase";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';


import { useHistory } from 'react-router-dom'


const Pageint = ({ alert }) => {

    let history = useHistory();    

// STATE

// MODE (payant/gratuit ; mdscs/ines)
const [ModeGratuit, setModeGratuit] = useState(false);
const [ModeInes, setModeInes] = useState(true);

// LETTRE
const [Lettreinfo, setLettreinfo] = useState("E");
const [Lettrecible, setLettrecible] = useState("E");
const [Lettreclinique, setLettreclinique] = useState("E");
const [Lettreediteur, setLettreediteur] = useState("E");
const [Lettregenerale, setLettregenerale] = useState("E");

// VARIABLE DE FONCTIONNEMENT

const [Eliminatoire, setEliminatoire] = useState(0);
const [Eliminatoireaff, setEliminatoireaff] = useState(0);
const [Itemnegatif, setItemnegatif] = useState(0);
const [Itemnegatifaff, setItemnegatifaff] = useState(0);
const [Displaynegatif, setDisplaynegatif] = useState("none");
const [Displaynegatifaff, setDisplaynegatifaff] = useState("none");
const [Excel, setExcel] = useState("");
const [Displayaff, setDisplayaff] = useState("none");
const [Infopositionscore, setInfopositionscore] = useState("");
const [Infopositionscoreaff, setInfopositionscoreaff] = useState("");

const [FR, setFR] = useState(true);


// POINT MAX PAR QUESTION
const [MaxP1Q1, setMaxP1Q1] = useState(0);
const [MaxP1Q2, setMaxP1Q2] = useState(0);
const [MaxP1Q3, setMaxP1Q3] = useState(0);
const [MaxP1Q4, setMaxP1Q4] = useState(0);
const [MaxP1Q4b, setMaxP1Q4b] = useState(0);
const [MaxP1Q5, setMaxP1Q5] = useState(0);
const [MaxP1Q6, setMaxP1Q6] = useState(0);
const [MaxP1Criticite, setMaxP1Criticite] = useState(65);

const [MaxP2Q1, setMaxP2Q1] = useState(0);
const [MaxP2Q2, setMaxP2Q2] = useState(0);
const [MaxP2Q3, setMaxP2Q3] = useState(0);
const [MaxP2Q4, setMaxP2Q4] = useState(0);
const [MaxP2Q5, setMaxP2Q5] = useState(0);

const [MaxP3Q1, setMaxP3Q1] = useState(0);
const [MaxP3Q2, setMaxP3Q2] = useState(0);
const [MaxP3Q3, setMaxP3Q3] = useState(0);
const [MaxP3Q4, setMaxP3Q4] = useState(0);

const [MaxP4Q1, setMaxP4Q1] = useState(0);
const [MaxP4Q2, setMaxP4Q2] = useState(0);
const [MaxP4Q3, setMaxP4Q3] = useState(0);
const [MaxP4Q4, setMaxP4Q4] = useState(0);
const [MaxP4Q5, setMaxP4Q5] = useState(0);
const [MaxP4Q6, setMaxP4Q6] = useState(0);
const [MaxP4Q7, setMaxP4Q7] = useState(0);
const [MaxP4Q8, setMaxP4Q8] = useState(0);
const [MaxP4Q910, setMaxP4Q910] = useState(0);


// POINT PAR QUESTION

const [PointP1Q0, setPointP1Q0] = useState(0);
const [PointP1Q1, setPointP1Q1] = useState(0);
const [PointP1Q2, setPointP1Q2] = useState(0);
const [PointP1Q3, setPointP1Q3] = useState(0);
const [PointP1Q4, setPointP1Q4] = useState(0);
const [PointP1Q4b, setPointP1Q4b] = useState(0);
const [PointP1Q5, setPointP1Q5] = useState(0);
const [PointP1Q6, setPointP1Q6] = useState(0);
const [PointP1Criticite, setPointP1Criticite] = useState(0);

const [PointP2Q1, setPointP2Q1] = useState(0);
const [PointP2Q2, setPointP2Q2] = useState(0);
const [PointP2Q3, setPointP2Q3] = useState(0);
const [PointP2Q4, setPointP2Q4] = useState(0);
const [PointP2Q5, setPointP2Q5] = useState(0);

const [PointP3Q1, setPointP3Q1] = useState(0);
const [PointP3Q2, setPointP3Q2] = useState(0);
const [PointP3Q3, setPointP3Q3] = useState(0);
const [PointP3Q4, setPointP3Q4] = useState(0);

const [PointP4Q0, setPointP4Q0] = useState(0);
const [PointP4Q1, setPointP4Q1] = useState(0);
const [PointP4Q2, setPointP4Q2] = useState(0);
const [PointP4Q3, setPointP4Q3] = useState(0);
const [PointP4Q4, setPointP4Q4] = useState(0);
const [PointP4Q5, setPointP4Q5] = useState(0);
const [PointP4Q6, setPointP4Q6] = useState(0);
const [PointP4Q7, setPointP4Q7] = useState(0);
const [PointP4Q8, setPointP4Q8] = useState(0);
const [PointP4Q910, setPointP4Q910] = useState(0);

const [PointPartie1, setPointPartie1] = useState(0);
const [PointPartie2, setPointPartie2] = useState(0);
const [PointPartie3, setPointPartie3] = useState(0);
const [PointPartie4, setPointPartie4] = useState(0);
const [PointTotal, setPointTotal] = useState(0);

const [Pointsur20Partie1, setPointsur20Partie1] = useState(0);
const [Pointsur20Partie2, setPointsur20Partie2] = useState(0);
const [Pointsur20Partie3, setPointsur20Partie3] = useState(0);
const [Pointsur20Partie4, setPointsur20Partie4] = useState(0);
const [Pointsur20Total, setPointsur20Total] = useState(0);

// SCORE AFFICHE
const [PointPartie1aff, setPointPartie1aff] = useState("");
const [PointPartie2aff, setPointPartie2aff] = useState("");
const [PointPartie3aff, setPointPartie3aff] = useState("");
const [PointPartie4aff, setPointPartie4aff] = useState("");
const [PointTotalaff, setPointTotalaff] = useState("");

const [Pointsur20Partie1aff, setPointsur20Partie1aff] = useState("");
const [Pointsur20Partie2aff, setPointsur20Partie2aff] = useState("");
const [Pointsur20Partie3aff, setPointsur20Partie3aff] = useState("");
const [Pointsur20Partie4aff, setPointsur20Partie4aff] = useState("");
const [Pointsur20Totalaff, setPointsur20Totalaff] = useState("");

const [MaxPartie1, setMaxPartie1] = useState(0);
const [MaxPartie2, setMaxPartie2] = useState(0);
const [MaxPartie3, setMaxPartie3] = useState(0);
const [MaxPartie4, setMaxPartie4] = useState(0);
const [PointMax, setPointMax] = useState(0);



// INFO UTILISATEUR
const [P0Q1R, setP0Q1R] = useState("");
const [P0Q2R, setP0Q2R] = useState("");
const [P0Q3R, setP0Q3R] = useState("");
const [P0Q4R, setP0Q4R] = useState("");

// INFO UTILISATEUR
const [P0nomsolution, setP0nomsolution] = useState("");
const [P0nomsolutionaff, setP0nomsolutionaff] = useState("");

// MAIL UTILISATEUR
const [P0mail, setP0mail] = useState("");

// SELECTION DES REPONSES

//P1

const [P1Q0R1, setP1Q0R1] = useState(0);
const [P1Q0R2, setP1Q0R2] = useState(0);
const [P1Q0R3, setP1Q0R3] = useState(0);
const [P1Q0R4, setP1Q0R4] = useState(0);

const [P1Q1R1, setP1Q1R1] = useState(0);
const [P1Q1R2, setP1Q1R2] = useState(0);
const [P1Q1R3, setP1Q1R3] = useState(0);
const [P1Q1R4, setP1Q1R4] = useState(0);
const [P1Q1R5, setP1Q1R5] = useState(0);
const [P1Q1R6, setP1Q1R6] = useState(0);
const [P1Q1R7, setP1Q1R7] = useState(0);
const [P1Q1R8, setP1Q1R8] = useState(0);
const [P1Q1R9, setP1Q1R9] = useState(0);

const [P1Q2R1, setP1Q2R1] = useState(0);
const [P1Q2R2, setP1Q2R2] = useState(0);
const [P1Q2R3, setP1Q2R3] = useState(0);
const [P1Q2R4, setP1Q2R4] = useState(0);
const [P1Q2R5, setP1Q2R5] = useState(0);
const [P1Q2R6, setP1Q2R6] = useState(0);
const [P1Q2R7, setP1Q2R7] = useState(0);
const [P1Q2R8, setP1Q2R8] = useState(0);
const [P1Q2R9, setP1Q2R9] = useState(0);
const [P1Q2R10, setP1Q2R10] = useState(0);
const [P1Q2R11, setP1Q2R11] = useState(0);
const [P1Q2R12, setP1Q2R12] = useState(0);
const [P1Q2R13, setP1Q2R13] = useState(0);
const [P1Q2R14, setP1Q2R14] = useState(0);
const [P1Q2R15, setP1Q2R15] = useState(0);
const [P1Q2R16, setP1Q2R16] = useState(0);
const [P1Q2R17, setP1Q2R17] = useState(0);
const [P1Q2R18, setP1Q2R18] = useState(0);
const [P1Q2R19, setP1Q2R19] = useState(0);
const [P1Q2R20, setP1Q2R20] = useState(0);
const [P1Q2R21, setP1Q2R21] = useState(0);
const [P1Q2R22, setP1Q2R22] = useState(0);

const [P1Q3R1, setP1Q3R1] = useState(0);
const [P1Q3R2, setP1Q3R2] = useState(0);
const [P1Q3R3, setP1Q3R3] = useState(0);

const [P1Q4R1, setP1Q4R1] = useState(0);
const [P1Q4R2, setP1Q4R2] = useState(0);
const [P1Q4R3, setP1Q4R3] = useState(0);
const [P1Q4R4, setP1Q4R4] = useState(0);
const [P1Q4R5, setP1Q4R5] = useState(0);

const [P1Q4bR1, setP1Q4bR1] = useState(0);
const [P1Q4bR2, setP1Q4bR2] = useState(0);

const [P1Q4c1R1, setP1Q4c1R1] = useState(0);
const [P1Q4c1R2, setP1Q4c1R2] = useState(0);

const [P1Q4c2R1, setP1Q4c2R1] = useState(0);
const [P1Q4c2R2, setP1Q4c2R2] = useState(0);

const [P1Q5R1, setP1Q5R1] = useState(0);
const [P1Q5R2, setP1Q5R2] = useState(0);
const [P1Q5R3, setP1Q5R3] = useState(0);
const [P1Q5R4, setP1Q5R4] = useState(0);
const [P1Q5R5, setP1Q5R5] = useState(0);
const [P1Q5R6, setP1Q5R6] = useState(0);

const [P1Q6R1, setP1Q6R1] = useState(0);
const [P1Q6R2, setP1Q6R2] = useState(0);
const [P1Q6R3, setP1Q6R3] = useState(0);


//P2

const [P2Q1R1, setP2Q1R1] = useState(0);
const [P2Q1R2, setP2Q1R2] = useState(0);
const [P2Q1R3, setP2Q1R3] = useState(0);

const [P2Q2Rinput, setP2Q2Rinput] = useState("");
const [P2Q2R1, setP2Q2R1] = useState("");
const [P2Q2R2, setP2Q2R2] = useState("");
const [P2Q2R3, setP2Q2R3] = useState("");
const [P2Q2R4, setP2Q2R4] = useState("");


const [P2Q3R1, setP2Q3R1] = useState(0);
const [P2Q3R2, setP2Q3R2] = useState(0);

const [P2Q4R1, setP2Q4R1] = useState(0);
const [P2Q4R2, setP2Q4R2] = useState(0);
const [P2Q4R3, setP2Q4R3] = useState(0);
const [P2Q4R4, setP2Q4R4] = useState(0);
const [P2Q4R5, setP2Q4R5] = useState(0);

const [P2Q5R1, setP2Q5R1] = useState(0);
const [P2Q5R2, setP2Q5R2] = useState(0);
const [P2Q5R3, setP2Q5R3] = useState(0);
const [P2Q5R4, setP2Q5R4] = useState(0);

const [P3Q1R1, setP3Q1R1] = useState(0);
const [P3Q1R2, setP3Q1R2] = useState(0);
const [P3Q1R3, setP3Q1R3] = useState(0);
const [P3Q1R4, setP3Q1R4] = useState(0);
const [P3Q1R5, setP3Q1R5] = useState(0);
const [P3Q1R6, setP3Q1R6] = useState(0);
const [P3Q1R7, setP3Q1R7] = useState(0);
const [P3Q1R8, setP3Q1R8] = useState(0);
const [P3Q1R9, setP3Q1R9] = useState(0);
const [P3Q1R10, setP3Q1R10] = useState(0);
const [P3Q1R11, setP3Q1R11] = useState(0);

const [P3Q2R1, setP3Q2R1] = useState(0);
const [P3Q2R2, setP3Q2R2] = useState(0);
const [P3Q2R3, setP3Q2R3] = useState(0);
const [P3Q2R4, setP3Q2R4] = useState(0);

const [P3Q3R1, setP3Q3R1] = useState(0);
const [P3Q3R2, setP3Q3R2] = useState(0);

const [P3Q4R1, setP3Q4R1] = useState(0);
const [P3Q4R2, setP3Q4R2] = useState(0);
const [P3Q4R3, setP3Q4R3] = useState(0);
const [P3Q4R4, setP3Q4R4] = useState(0);
const [P3Q4R5, setP3Q4R5] = useState(0);
const [P3Q4R6, setP3Q4R6] = useState(0);
const [P3Q4R7, setP3Q4R7] = useState(0);
const [P3Q4R8, setP3Q4R8] = useState(0);

//P4

const [P4Q0R1, setP4Q0R1] = useState(0);
const [P4Q0R2, setP4Q0R2] = useState(0);
const [P4Q0R3, setP4Q0R3] = useState(0);
const [P4Q0R4, setP4Q0R4] = useState(0);

const [P4Q1R1, setP4Q1R1] = useState(0);
const [P4Q1R2, setP4Q1R2] = useState(0);
const [P4Q1R3, setP4Q1R3] = useState(0);
const [P4Q1R4, setP4Q1R4] = useState(0);

const [P4Q2R1, setP4Q2R1] = useState(0);
const [P4Q2R2, setP4Q2R2] = useState(0);
const [P4Q2R3, setP4Q2R3] = useState(0);
const [P4Q2R4, setP4Q2R4] = useState(0);
const [P4Q2R5, setP4Q2R5] = useState(0);
const [P4Q2R6, setP4Q2R6] = useState(0);
const [P4Q2R7, setP4Q2R7] = useState(0);
const [P4Q2R8, setP4Q2R8] = useState(0);
const [P4Q2R9, setP4Q2R9] = useState(0);

const [P4Q3R1, setP4Q3R1] = useState(0);
const [P4Q3R2, setP4Q3R2] = useState(0);
const [P4Q3R3, setP4Q3R3] = useState(0);

const [P4Q4R1, setP4Q4R1] = useState(0);
const [P4Q4R2, setP4Q4R2] = useState(0);
const [P4Q4R3, setP4Q4R3] = useState(0);
const [P4Q4R4, setP4Q4R4] = useState(0);
const [P4Q4R5, setP4Q4R5] = useState(0);
const [P4Q4R6, setP4Q4R6] = useState(0);
const [P4Q4R7, setP4Q4R7] = useState(0);

const [P4Q5Rinput, setP4Q5Rinput] = useState("");

const [P4Q6R1, setP4Q6R1] = useState(0);
const [P4Q6R2, setP4Q6R2] = useState(0);
const [P4Q6R3, setP4Q6R3] = useState(0);
const [P4Q6R4, setP4Q6R4] = useState(0);

const [P4Q7R1, setP4Q7R1] = useState(0);
const [P4Q7R2, setP4Q7R2] = useState(0);

const [P4Q8R1, setP4Q8R1] = useState(0);
const [P4Q8R2, setP4Q8R2] = useState(0);
const [P4Q8R3, setP4Q8R3] = useState(0);

const [P4Q9R1, setP4Q9R1] = useState(0);
const [P4Q9R2, setP4Q9R2] = useState(0);
const [P4Q9R3, setP4Q9R3] = useState(0);

const [P4Q10R1, setP4Q10R1] = useState(0); // ELEVEE
const [P4Q10R2, setP4Q10R2] = useState(0); // MOYENNE
const [P4Q10R3, setP4Q10R3] = useState(0); // FAIBLE
const [P4Q10texte, setP4Q10texte] = useState("");
const [P4Q10texteTraduit, setP4Q10texteTraduit] = useState("");

// VARIABLE INFO VERSION INVESTISSEUR
    // Question dernier CA :
const [P4Q11R1, setP4Q11R1] = useState(0);
const [P4Q11R2, setP4Q11R2] = useState(0);
const [P4Q11R3, setP4Q11R3] = useState(0);
const [P4Q11R4, setP4Q11R4] = useState(0);
const [P4Q11R5, setP4Q11R5] = useState(0);
const [P4Q11R6, setP4Q11R6] = useState(0);
    
        // Question dernier EBITA :
const [P4Q12R1, setP4Q12R1] = useState(0);
const [P4Q12R2, setP4Q12R2] = useState(0);
const [P4Q12R3, setP4Q12R3] = useState(0);
const [P4Q12R4, setP4Q12R4] = useState(0);
const [P4Q12R5, setP4Q12R5] = useState(0);
const [P4Q12R6, setP4Q12R6] = useState(0);


//POINT APPORTE PAR LA VARIABLE

const [vP1Q0R1, setvP1Q0R1] = useState(0);
const [vP1Q0R2, setvP1Q0R2] = useState(0);
const [vP1Q0R3, setvP1Q0R3] = useState(40);
const [vP1Q0R4, setvP1Q0R4] = useState(80);

const [vP1Q1R1, setvP1Q1R1] = useState(0);
const [vP1Q1R2, setvP1Q1R2] = useState(50);
const [vP1Q1R3, setvP1Q1R3] = useState(70);
const [vP1Q1R4, setvP1Q1R4] = useState(40);
const [vP1Q1R5, setvP1Q1R5] = useState(70);
const [vP1Q1R6, setvP1Q1R6] = useState(85);
const [vP1Q1R7, setvP1Q1R7] = useState(50);
const [vP1Q1R8, setvP1Q1R8] = useState(50);
const [vP1Q1R9, setvP1Q1R9] = useState(30);

const [vP1Q2R1, setvP1Q2R1] = useState(0);
const [vP1Q2R2, setvP1Q2R2] = useState(0);
const [vP1Q2R3, setvP1Q2R3] = useState(0);
const [vP1Q2R4, setvP1Q2R4] = useState(0);
const [vP1Q2R5, setvP1Q2R5] = useState(0);
const [vP1Q2R6, setvP1Q2R6] = useState(0);
const [vP1Q2R7, setvP1Q2R7] = useState(0);
const [vP1Q2R8, setvP1Q2R8] = useState(0);
const [vP1Q2R9, setvP1Q2R9] = useState(0);
const [vP1Q2R10, setvP1Q2R10] = useState(0);
const [vP1Q2R11, setvP1Q2R11] = useState(0);
const [vP1Q2R12, setvP1Q2R12] = useState(0);
const [vP1Q2R13, setvP1Q2R13] = useState(0);
const [vP1Q2R14, setvP1Q2R14] = useState(0);
const [vP1Q2R15, setvP1Q2R15] = useState(0);
const [vP1Q2R16, setvP1Q2R16] = useState(0);
const [vP1Q2R17, setvP1Q2R17] = useState(0);
const [vP1Q2R18, setvP1Q2R18] = useState(0);
const [vP1Q2R19, setvP1Q2R19] = useState(0);
const [vP1Q2R20, setvP1Q2R20] = useState(0);
const [vP1Q2R21, setvP1Q2R21] = useState(0);

const [vP1Q3R1, setvP1Q3R1] = useState(85);
const [vP1Q3R2, setvP1Q3R2] = useState(20);
const [vP1Q3R3, setvP1Q3R3] = useState(0);

const [vP1Q4R1, setvP1Q4R1] = useState(5);
const [vP1Q4R2, setvP1Q4R2] = useState(30);
const [vP1Q4R3, setvP1Q4R3] = useState(0);
const [vP1Q4R4, setvP1Q4R4] = useState(30);
const [vP1Q4R5, setvP1Q4R5] = useState(-80);

const [vP1Q4bR1, setvP1Q4bR1] = useState(-80);
const [vP1Q4bR2, setvP1Q4bR2] = useState(0);

const [vP1Q5R1, setvP1Q5R1] = useState(0);
const [vP1Q5R2, setvP1Q5R2] = useState(20);
const [vP1Q5R3, setvP1Q5R3] = useState(50);
const [vP1Q5R4, setvP1Q5R4] = useState(70);
const [vP1Q5R5, setvP1Q5R5] = useState(80);
const [vP1Q5R6, setvP1Q5R6] = useState(50);

const [vP1Q6R1, setvP1Q6R1] = useState(85);
const [vP1Q6R2, setvP1Q6R2] = useState(50);
const [vP1Q6R3, setvP1Q6R3] = useState(0);

const [vP2Q1R1, setvP2Q1R1] = useState(60);
const [vP2Q1R2, setvP2Q1R2] = useState(20);
const [vP2Q1R3, setvP2Q1R3] = useState(30);

const [vP2Q2R1, setvP2Q2R1] = useState(15);
const [vP2Q2R2, setvP2Q2R2] = useState(40);
const [vP2Q2R3, setvP2Q2R3] = useState(70);
const [vP2Q2R4, setvP2Q2R4] = useState(100);

const [vP2Q3R1, setvP2Q3R1] = useState(100);
const [vP2Q3R2, setvP2Q3R2] = useState(0);

const [vP2Q4R1, setvP2Q4R1] = useState(130);
const [vP2Q4R2, setvP2Q4R2] = useState(80);
const [vP2Q4R3, setvP2Q4R3] = useState(50);
const [vP2Q4R4, setvP2Q4R4] = useState(-80);
const [vP2Q4R5, setvP2Q4R5] = useState(80);

const [vP2Q5R1, setvP2Q5R1] = useState(20);
const [vP2Q5R2, setvP2Q5R2] = useState(60);
const [vP2Q5R3, setvP2Q5R3] = useState(0);
const [vP2Q5R4, setvP2Q5R4] = useState(40);

const [vP3Q1R1, setvP3Q1R1] = useState(80);
const [vP3Q1R2, setvP3Q1R2] = useState(50);
const [vP3Q1R3, setvP3Q1R3] = useState(50);
const [vP3Q1R4, setvP3Q1R4] = useState(50);
const [vP3Q1R5, setvP3Q1R5] = useState(50);
const [vP3Q1R6, setvP3Q1R6] = useState(50);
const [vP3Q1R7, setvP3Q1R7] = useState(50);
const [vP3Q1R8, setvP3Q1R8] = useState(50);
const [vP3Q1R9, setvP3Q1R9] = useState(50);
const [vP3Q1R10, setvP3Q1R10] = useState(50);
const [vP3Q1R11, setvP3Q1R11] = useState(30);

const [vP3Q2R1, setvP3Q2R1] = useState(-80);
const [vP3Q2R2, setvP3Q2R2] = useState(-80);
const [vP3Q2R3, setvP3Q2R3] = useState(10);
const [vP3Q2R4, setvP3Q2R4] = useState(20);

const [vP3Q3R1, setvP3Q3R1] = useState(40);
const [vP3Q3R2, setvP3Q3R2] = useState(0);

const [vP3Q4R1, setvP3Q4R1] = useState(70);
const [vP3Q4R2, setvP3Q4R2] = useState(190);
const [vP3Q4R3, setvP3Q4R3] = useState(170);
const [vP3Q4R4, setvP3Q4R4] = useState(50);
const [vP3Q4R5, setvP3Q4R5] = useState(40);
const [vP3Q4R6, setvP3Q4R6] = useState(30);
const [vP3Q4R7, setvP3Q4R7] = useState(10);
const [vP3Q4R8, setvP3Q4R8] = useState(-80);

const [vP4Q0R1, setvP4Q0R1] = useState(0);
const [vP4Q0R2, setvP4Q0R2] = useState(0);
const [vP4Q0R3, setvP4Q0R3] = useState(40);
const [vP4Q0R4, setvP4Q0R4] = useState(80);

const [vP4Q1R1, setvP4Q1R1] = useState(30);
const [vP4Q1R2, setvP4Q1R2] = useState(15);
const [vP4Q1R3, setvP4Q1R3] = useState(15);
const [vP4Q1R4, setvP4Q1R4] = useState(-30); // POURCENTAGE DE DIMINUTION DE LA PARTIE 4

const [vP4Q2R1, setvP4Q2R1] = useState(50);
const [vP4Q2R2, setvP4Q2R2] = useState(25);
const [vP4Q2R3, setvP4Q2R3] = useState(30);
const [vP4Q2R4, setvP4Q2R4] = useState(15);
const [vP4Q2R5, setvP4Q2R5] = useState(20);
const [vP4Q2R6, setvP4Q2R6] = useState(10);
const [vP4Q2R7, setvP4Q2R7] = useState(10);
const [vP4Q2R8, setvP4Q2R8] = useState(5);
const [vP4Q2R9, setvP4Q2R9] = useState(0);

const [vP4Q3R1, setvP4Q3R1] = useState(-80);
const [vP4Q3R2, setvP4Q3R2] = useState(60);
const [vP4Q3R3, setvP4Q3R3] = useState(100);

const [vP4Q4R1, setvP4Q4R1] = useState(50);
const [vP4Q4R2, setvP4Q4R2] = useState(25);
const [vP4Q4R3, setvP4Q4R3] = useState(70);
const [vP4Q4R4, setvP4Q4R4] = useState(35);
const [vP4Q4R5, setvP4Q4R5] = useState(20);
const [vP4Q4R6, setvP4Q4R6] = useState(10);
const [vP4Q4R7, setvP4Q4R7] = useState(-80);


const [vP4Q6R1, setvP4Q6R1] = useState(80);
const [vP4Q6R2, setvP4Q6R2] = useState(50);
const [vP4Q6R3, setvP4Q6R3] = useState(30);
const [vP4Q6R4, setvP4Q6R4] = useState(0);

const [vP4Q7R1, setvP4Q7R1] = useState(50);
const [vP4Q7R2, setvP4Q7R2] = useState(0);

const [vP4Q8R1, setvP4Q8R1] = useState(-80);
const [vP4Q8R2, setvP4Q8R2] = useState(0);
const [vP4Q8R3, setvP4Q8R3] = useState(30);

const [vP4Q9R1, setvP4Q9R1] = useState(0);
const [vP4Q9R2, setvP4Q9R2] = useState(30);
const [vP4Q9R3, setvP4Q9R3] = useState(130);

const [vP4Q10R1, setvP4Q10R1] = useState(90);
const [vP4Q10R2, setvP4Q10R2] = useState(30);
const [vP4Q10R3, setvP4Q10R3] = useState(0);

const [date, setdate] = useState("");

// FONCTION FIRESTORE

var tutorialsRef = firebase.firestore().collection("/invest_INT");

// Heure
useEffect (
    function() {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1; // Les mois commencent à 0 en JavaScript
        let day = date.getDate();

        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();

        setdate(`${year}.${month < 10 ? "0" + month : month}.${day < 10 ? "0" + day : day} ${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}`)

    }
)


// FONCTION LETTRE EVAL

useEffect (
    function() {

        //INFO

        if (Pointsur20Partie1 <8){
            setLettreinfo("E")
        }

        if (Pointsur20Partie1 >=8 & Pointsur20Partie1<10){
            setLettreinfo("D")
        }

        if (Pointsur20Partie1 >=10 & Pointsur20Partie1<13){
            setLettreinfo("C")
        }

        if (Pointsur20Partie1 >=13 & Pointsur20Partie1<15){
            setLettreinfo("B")
        }

        if (Pointsur20Partie1 >=15){
            setLettreinfo("A")
        }

        //CIBLE
        if (Pointsur20Partie2 <8){
            setLettrecible("E")
        }

        if (Pointsur20Partie2 >=8 & Pointsur20Partie2<10){
            setLettrecible("D")
        }

        if (Pointsur20Partie2 >=10 & Pointsur20Partie2<13){
            setLettrecible("C")
        }

        if (Pointsur20Partie2 >=13 & Pointsur20Partie2<15){
            setLettrecible("B")
        }

        if (Pointsur20Partie2 >=15){
            setLettrecible("A")
        }

        //CLINIQUE
        if (Pointsur20Partie3 <8){
            setLettreclinique("E")
        }

        if (Pointsur20Partie3 >=8 & Pointsur20Partie3<10){
            setLettreclinique("D")
        }

        if (Pointsur20Partie3 >=10 & Pointsur20Partie3<13){
            setLettreclinique("C")
        }

        if (Pointsur20Partie3 >=13 & Pointsur20Partie3<15){
            setLettreclinique("B")
        }

        if (Pointsur20Partie3 >=15){
            setLettreclinique("A")
        }

        //EDITEUR
        if (Pointsur20Partie4 <8){
            setLettreediteur("E")
        }

        if (Pointsur20Partie4 >=8 & Pointsur20Partie4<10){
            setLettreediteur("D")
        }

        if (Pointsur20Partie4 >=10 & Pointsur20Partie4<13){
            setLettreediteur("C")
        }

        if (Pointsur20Partie4 >=13 & Pointsur20Partie4<15){
            setLettreediteur("B")
        }

        if (Pointsur20Partie4 >=15){
            setLettreediteur("A")
        }

        // SCORE GENERAL
        if (Pointsur20Total <8){
            setLettregenerale("E")
        }

        if (Pointsur20Total >=8 & Pointsur20Total<10){
            setLettregenerale("D")
        }

        if (Pointsur20Total >=10 & Pointsur20Total<13){
            setLettregenerale("C")
        }

        if (Pointsur20Total >=13 & Pointsur20Total<15){
            setLettregenerale("B")
        }

        if (Pointsur20Total >=15){
            setLettregenerale("A")
        }
    }


)


// FONCTION LANGUE

    const onClickFR =function() {
            setFR(true)
        }

    const onClickEN =function() {
        setFR(false)
    }

// FONCTION INFO POSITION SCORE

useEffect(
    function() {

            setInfopositionscore("")


            if(Pointsur20Total>=14) {
                setInfopositionscore("1st quartile")
            }


            if(Pointsur20Total>=11 & Pointsur20Total<14) {
                setInfopositionscore("2nd quartile")
            }


            if(Pointsur20Total<11) {
                setInfopositionscore("below the median")
            }




    }

)

// FONCTION ITEM A POINTS NEGATIFS

useEffect (
    function() {
        setItemnegatif(0)
        setDisplaynegatif('none')

        if ((P1Q4R3==1 & (P1Q4c1R1==0 & P1Q4c2R1==0)) | (vP1Q1R1===-80 & P1Q1R1===1) | (vP1Q1R2===-80 & P1Q1R2===1)  | (vP1Q1R3===-80 & P1Q1R3===1) | (vP1Q1R4===-80 & P1Q1R4===1) | (vP1Q1R5===-80 & P1Q1R5===1) | (vP1Q1R6===-80 & P1Q1R6===1) | (vP1Q1R7===-80 & P1Q1R7===1) | (vP1Q1R8===-80 & P1Q1R8===1) | (vP1Q1R9===-80 & P1Q1R9===1) | (vP1Q2R1===-80 & P1Q2R1===1) | (vP1Q2R2===-80 & P1Q2R2===1) | (vP1Q2R3===-80 & P1Q2R3===1) | (vP1Q2R4===-80 & P1Q2R4===1) | (vP1Q2R5===-80 & P1Q2R5===1) | (vP1Q2R6===-80 & P1Q2R6===1) | (vP1Q2R7===-80 & P1Q2R7===1) | (vP1Q2R8===-80 & P1Q2R8===1) | (vP1Q2R9===-80 & P1Q2R9===1) | (vP1Q2R10===-80 & P1Q2R10===1) | (vP1Q2R11===-80 & P1Q2R11===1) | (vP1Q2R12===-80 & P1Q2R12===1) | (vP1Q2R13===-80 & P1Q2R13===1) | (vP1Q2R14===-80 & P1Q2R14===1) | (vP1Q2R15===-80 & P1Q2R15===1) | (vP1Q2R16===-80 & P1Q2R16===1) | (vP1Q2R17===-80 & P1Q2R17===1) | (vP1Q2R18===-80 & P1Q2R18===1) | (vP1Q3R1===-80 & P1Q3R1===1) | (vP1Q3R2===-80 & P1Q3R2===1) | (vP1Q3R3===-80 & P1Q3R3===1) | (vP1Q4R1===-80 & P1Q4R1===1) | (vP1Q4R2===-80 & P1Q4R2===1) | (vP1Q4R3===-80 & P1Q4R3===1) | (vP1Q4R4===-80 & P1Q4R4===1) | (vP1Q4R5===-80 & P1Q4R5===1) | (P1Q4bR1===1) | (vP1Q5R1===-80 & P1Q5R1===1) | (vP1Q5R2===-80 & P1Q5R2===1) | (vP1Q5R3===-80 & P1Q5R3===1) | (vP1Q5R4===-80 & P1Q5R4===1) | (vP1Q5R5===-80 & P1Q5R5===1) | (vP1Q5R6===-80 & P1Q5R6===1) | (vP2Q1R1===-80 & P2Q1R1===1) | (vP2Q1R2===-80 & P2Q1R2===1) | (vP2Q1R3===-80 & P2Q1R3===1) | (vP2Q2R1===-80 & P2Q2R1===1) | (vP2Q2R2===-80 & P2Q2R2===1) | (vP2Q2R3===-80 & P2Q2R3===1) | (vP2Q2R4===-80 & P2Q2R4===1) | (vP2Q3R1===-80 & P2Q3R1===1) | (vP2Q3R2===-80 & P2Q3R2===1) | (vP2Q4R1===-80 & P2Q4R1===1) | (vP2Q4R2===-80 & P2Q4R2===1) | (vP2Q4R3===-80 & P2Q4R3===1) | (vP2Q4R4===-80 & P2Q4R4===1) | (vP2Q5R1===-80 & P2Q5R1===1) | (vP2Q5R2===-80 & P2Q5R2===1) | (vP2Q5R3===-80 & P2Q5R3===1) | (vP2Q5R4===-80 & P2Q5R4===1) | (vP3Q1R1===-80 & P3Q1R1===1) | (vP3Q1R2===-80 & P3Q1R2===1) | (vP3Q1R3===-80 & P3Q1R3===1) | (vP3Q1R4===-80 & P3Q1R4===1) | (vP3Q1R5===-80 & P3Q1R5===1) | (vP3Q1R6===-80 & P3Q1R6===1) | (vP3Q1R7===-80 & P3Q1R7===1) | (vP3Q1R8===-80 & P3Q1R8===1) | (vP3Q1R9===-80 & P3Q1R9===1) | (vP3Q1R10===-80 & P3Q1R10===1) | (vP3Q1R11===-80 & P3Q1R11===1) | (vP3Q2R1===-80 & P3Q2R1===1) | (vP3Q2R2===-80 & P3Q2R2===1) | (vP3Q2R3===-80 & P3Q2R3===1) | (vP3Q2R3===-80 & P3Q2R3===1) | (vP3Q2R4===-80 & P3Q2R4===1) | (vP3Q3R1===-80 & P3Q3R1===1) | (vP3Q3R2===-80 & P3Q3R2===1) | (vP3Q4R1===-80 & P3Q4R1===1) | (vP3Q4R2===-80 & P3Q4R2===1) | (vP3Q4R3===-80 & P3Q4R3===1) | (vP3Q4R4===-80 & P3Q4R4===1) | (vP3Q4R5===-80 & P3Q4R5===1) | (vP3Q4R6===-80 & P3Q4R6===1) | (vP3Q4R7===-80 & P3Q4R7===1) | (vP3Q4R8===-80 & P3Q4R8===1) | (vP4Q1R1===-80 & P4Q1R1===1) | (vP4Q1R2===-80 & P4Q1R2===1) | (vP4Q1R3===-80 & P4Q1R3===1) | (vP4Q1R4===-80 & P4Q1R4===1) | (vP4Q2R1===-80 & P4Q2R1===1) | (vP4Q2R2===-80 & P4Q2R2===1) | (vP4Q2R3===-80 & P4Q2R3===1) | (vP4Q2R4===-80 & P4Q2R4===1) | (vP4Q2R5===-80 & P4Q2R5===1) | (vP4Q2R6===-80 & P4Q2R6===1) | (vP4Q2R7===-80 & P4Q2R7===1) | (vP4Q2R8===-80 & P4Q2R8===1) | (vP4Q2R9===-80 & P4Q2R9===1) | (vP4Q3R1===-80 & P4Q3R1===1) | (vP4Q3R2===-80 & P4Q3R2===1) | (vP4Q3R3===-80 & P4Q3R3===1) | (vP4Q4R1===-80 & P4Q4R1===1) | (vP4Q4R2===-80 & P4Q4R2===1) | (vP4Q4R3===-80 & P4Q4R3===1) | (vP4Q4R4===-80 & P4Q4R4===1) | (vP4Q4R5===-80 & P4Q4R5===1) | (vP4Q4R6===-80 & P4Q4R6===1) | (vP4Q4R7===-80 & P4Q4R7===1) | (vP4Q6R1===-80 & P4Q6R1===1) | (vP4Q6R2===-80 & P4Q6R2===1) | (vP4Q6R3===-80 & P4Q6R3===1) | (vP4Q6R4===-80 & P4Q6R4===1) | (vP4Q7R1===-80 & P4Q7R1===1) | (vP4Q7R2===-80 & P4Q7R2===1) | (vP4Q8R1===-80 & P4Q8R1===1) | (vP4Q8R2===-80 & P4Q8R2===1) | (vP4Q8R3===-80 & P4Q8R3===1) | (vP4Q9R1===-80 & P4Q9R1===1) | (vP4Q9R2===-80 & P4Q9R2===1) | (vP4Q9R3===-80 & P4Q9R3===1))
        {
            setItemnegatif(1)
            setDisplaynegatif('block')
        }
    }

)

// POPUP SI DOMAINE DU BIEN ETRE

// useEffect (
//     function() {

//         if (P1Q1R1==1)
//         {
//             alert("score is not relevant for wellness solutions")
//             setP1Q1R1(0)
//         }
//     }

// )

//FONCTION POINT MAX



// P1Q1
useEffect (
    function() {
        var tab = [vP1Q1R1, vP1Q1R2, vP1Q1R3, vP1Q1R4, vP1Q1R5, vP1Q1R6, vP1Q1R7, vP1Q1R8, vP1Q1R9]
        var x
        var y
        
        for (let i = 0; i < 9; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P1Q1R1 + tab[1]*P1Q1R2 + tab[2]*P1Q1R3 + tab[3]*P1Q1R4 + tab[4]*P1Q1R5 + tab[5]*P1Q1R6 + tab[6]*P1Q1R7 + tab[7]*P1Q1R8 + tab[8]*P1Q1R9

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]+tab[1]
        // IF ici si Pmax
        setMaxP1Q1(x)
        setPointP1Q1(y)
    }
)

// P1Q2
useEffect (
    function() {
        var tab = [vP1Q2R1, vP1Q2R2, vP1Q2R3, vP1Q2R4, vP1Q2R5, vP1Q2R6, vP1Q2R7, vP1Q2R8, vP1Q2R9, vP1Q2R10, vP1Q2R11, vP1Q2R12, vP1Q2R13, vP1Q2R14, vP1Q2R15, vP1Q2R16, vP1Q2R17, vP1Q2R18, vP1Q2R19, vP1Q2R20, vP1Q2R21]
        var x
        var y
        
        for (let i = 0; i < 21; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P1Q2R1 + tab[1]*P1Q2R2 + tab[2]*P1Q2R3 + tab[3]*P1Q2R4 + tab[4]*P1Q2R5 + tab[5]*P1Q2R6 + tab[6]*P1Q2R7 + tab[7]*P1Q2R8 + tab[8]*P1Q2R9 + tab[9]*P1Q2R10 + tab[10]*P1Q2R11 + tab[11]*P1Q2R12 + tab[12]*P1Q2R13 + tab[13]*P1Q2R14 + tab[14]*P1Q2R15 + tab[15]*P1Q2R16 + tab[16]*P1Q2R17 + tab[17]*P1Q2R18 + tab[18]*P1Q2R19 + tab[19]*P1Q2R20 + tab[20]*P1Q2R21

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]+tab[1]
        // IF ici si Pmax
        setMaxP1Q2(x)
        setPointP1Q2(y)
    }
)

// P1Q3
useEffect (
    function() {
        var tab = [vP1Q3R1, vP1Q3R2, vP1Q3R3]
        var x
        var y
        
        for (let i = 0; i < 3; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P1Q3R1 + tab[1]*P1Q3R2 + tab[2]*P1Q3R3
        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP1Q3(x)
        setPointP1Q3(y)
    }
)

// P1Q4
useEffect (
    function() {
        var tab = [vP1Q4R1, vP1Q4R2, vP1Q4R3, vP1Q4R4]
        var x
        var y

        var ai = 0
        
        for (let i = 0; i < 4; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P1Q4R1 + tab[1]*P1Q4R2 + tab[2]*P1Q4R3 + tab[3]*P1Q4R4

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax

          if (P1Q4R3==1 & (P1Q4c1R1==1 & P1Q4c2R1==1)){
              ai=30
          }

          if (P1Q4R3==1 & (P1Q4c1R1==0 & P1Q4c2R1==1)){
            ai=15
        }

        
        if (P1Q4R3==1 & (P1Q4c1R1==1 & P1Q4c2R1==0)){
            ai=15
        }

        if (P1Q4R3==1 & (P1Q4c1R1==0 & P1Q4c2R1==0)){
            ai=-40
        }

        y=ai+y


        setMaxP1Q4(x)
        setPointP1Q4(y)
    }
)

// P1Q4b
useEffect (
    function() {
        var tab = [vP1Q4bR1, vP1Q4bR2]
        var x
        var y
        
        for (let i = 0; i < 1; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=vP1Q4bR1*P1Q4bR1

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=0
        // IF ici si Pmax
        setMaxP1Q4b(x)
        setPointP1Q4b(y)
    }
)

// P1Q5
useEffect (
    function() {
        var tab = [vP1Q5R1, vP1Q5R2, vP1Q5R3, vP1Q5R4, vP1Q5R5, vP1Q5R6]
        var x
        var y
        
        for (let i = 0; i < 6; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P1Q5R1 + tab[1]*P1Q5R2 + tab[2]*P1Q5R3 + tab[3]*P1Q5R4 + tab[4]*P1Q5R5 + tab[5]*P1Q5R6

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP1Q5(x)
        setPointP1Q5(y)
    }
)

// P1Q6
useEffect (
    function() {
        var tab = [vP1Q6R1, vP1Q6R2, vP1Q6R3]
        var x
        var y
        
        for (let i = 0; i < 3; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P1Q6R1 + tab[1]*P1Q6R2 + tab[2]*P1Q6R3

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP1Q6(x)
        setPointP1Q6(y)
    }
)

// P1criticite
useEffect (
    function() {

        let a
        let b
        let c
        let d
        let e
        let f
        let g
        let h
        let i
        let j
        let k
        let l
        let m
        let n
        let o
        let p
        let q
        let r
        let s
        let t
        let u
        let v
        let w
        let x
        let y
        let z
        let totsur245
        let totsur100
        let totsur100arrondie

       
        // P1Q1
        a=vP1Q1R1*P1Q1R1
        b=vP1Q1R2*P1Q1R2
        c=vP1Q1R3*P1Q1R3
        d=vP1Q1R4*P1Q1R4
        e=vP1Q1R5*P1Q1R5
        f=vP1Q1R6*P1Q1R6
        g=vP1Q1R7*P1Q1R7
        h=vP1Q1R8*P1Q1R8
        i=vP1Q1R9*P1Q1R9


        //P3Q1
        
        j=vP3Q1R1*P3Q1R1
        k=vP3Q1R2*P3Q1R2
        l=vP3Q1R3*P3Q1R3
        m=vP3Q1R4*P3Q1R4
        n=vP3Q1R5*P3Q1R5
        o=vP3Q1R6*P3Q1R6
        p=vP3Q1R7*P3Q1R7
        q=vP3Q1R8*P3Q1R8
        r=vP3Q1R9*P3Q1R9
        s=vP3Q1R10*P3Q1R10
        t=vP3Q1R11*P3Q1R11

        var tabP1Q1 = [a, b, c, d, e, f, g, h, i]
        var tabP3Q1 = [j, k, l, m, n, o, p, q, r, s, t]

        const sortDesc = (a, b) => b - a;
        
        tabP1Q1.sort(sortDesc);
        tabP3Q1.sort(sortDesc);

        totsur245=tabP1Q1[0]+PointP1Q5+tabP3Q1[0]
        // SUR 65 POINTS
        totsur100=totsur245/245*65
        totsur100arrondie=parseInt(totsur100)
        

        setPointP1Criticite(totsur100arrondie)


    }
)

// P2Q1
useEffect (
    function() {
        var tab = [vP2Q1R1, vP2Q1R2, vP2Q1R3]
        var x
        var y
        
        for (let i = 0; i < 3; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P2Q1R1 + tab[1]*P2Q1R2 + tab[2]*P2Q1R3

        x=vP2Q1R1+vP2Q1R2+vP2Q1R3
        // IF ici si Pmax
        setMaxP2Q1(x)
        setPointP2Q1(y)
    }
)

// P2Q2
useEffect (

    
    
    function() {



        if (P2Q2Rinput == 0 | P2Q2Rinput== "") {
            setP2Q2R1(0)
            setP2Q2R2(0)
            setP2Q2R3(0)
            setP2Q2R4(0)
        }

        if (P2Q2Rinput < 10000 & P2Q2Rinput > 0){
            setP2Q2R1(1)
            setP2Q2R2(0)
            setP2Q2R3(0)
            setP2Q2R4(0)
        }

        if (P2Q2Rinput > 9999 & P2Q2Rinput<100000){
            setP2Q2R1(0)
            setP2Q2R2(1)
            setP2Q2R3(0)
            setP2Q2R4(0)
        }

        if (P2Q2Rinput > 99999 & P2Q2Rinput<1000000){
            setP2Q2R1(0)
            setP2Q2R2(0)
            setP2Q2R3(1)
            setP2Q2R4(0)
        }

        if (P2Q2Rinput > 999999){
            setP2Q2R1(0)
            setP2Q2R2(0)
            setP2Q2R3(0)
            setP2Q2R4(1)
        }

        var tab = [vP2Q2R1, vP2Q2R2, vP2Q2R3, vP2Q2R4]
        var x
        var y
        
        for (let i = 0; i < 4; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P2Q2R1 + tab[1]*P2Q2R2 + tab[2]*P2Q2R3 + tab[3]*P2Q2R4

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP2Q2(x)
        setPointP2Q2(y)

    }
)

// P2Q3
useEffect (
    function() {
        var tab = [vP2Q3R1, vP2Q3R2]
        var x
        var y
        
        for (let i = 0; i < 2; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P2Q3R1 + tab[1]*P2Q3R2

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP2Q3(x)
        setPointP2Q3(y)
    }
)

// P2Q4
useEffect (
    function() {
        var tab = [vP2Q4R1, vP2Q4R2, vP2Q4R3, vP2Q4R4, vP2Q4R5]
        var x
        var y
        
        for (let i = 0; i < 5; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P2Q4R1 + tab[1]*P2Q4R2 + tab[2]*P2Q4R3 + tab[3]*P2Q4R4 + tab[4]*P2Q4R5

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP2Q4(x)
        setPointP2Q4(y)
    }
)

// P2Q5
useEffect (
    function() {
        var tab = [vP2Q5R1, vP2Q5R2, vP2Q5R3, vP2Q5R4]
        var x
        var y
        
        for (let i = 0; i < 4; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P2Q5R1 + tab[1]*P2Q5R2 + tab[2]*P2Q5R3 + tab[3]*P2Q5R4

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP2Q5(x)
        setPointP2Q5(y)
    }
)

// P3Q1
useEffect (
    function() {
        var tab = [vP3Q1R1, vP3Q1R2, vP3Q1R3, vP3Q1R4, vP3Q1R5, vP3Q1R6, vP3Q1R7, vP3Q1R8, vP3Q1R9, vP3Q1R10, vP3Q1R11 ]
        var x
        var y
        
        for (let i = 0; i < 11; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P3Q1R1 + tab[1]*P3Q1R2 + tab[2]*P3Q1R3 + tab[3]*P3Q1R4 + tab[4]*P3Q1R5 + tab[5]*P3Q1R6 + tab[6]*P3Q1R7 + tab[7]*P3Q1R8 + tab[8]*P3Q1R9 + tab[9]*P3Q1R10 + tab[10]*P3Q1R11

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]+tab[1]+tab[2]
        // IF ici si Pmax
        setMaxP3Q1(x)
        setPointP3Q1(y)
    }
)

// P3Q2
useEffect (
    function() {
        var tab = [vP3Q2R1, vP3Q2R2, vP3Q2R3, vP3Q2R4]
        var x
        var y
        
        for (let i = 0; i < 4; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P3Q2R1 + tab[1]*P3Q2R2 + tab[2]*P3Q2R3 + tab[3]*P3Q2R4

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP3Q2(x)
        setPointP3Q2(y)
    }
)

// P3Q3
useEffect (
    function() {
        var tab = [vP3Q3R1, vP3Q3R2]
        var x
        var y
        
        for (let i = 0; i < 2; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P3Q3R1 + tab[1]*P3Q3R2

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP3Q3(x)
        setPointP3Q3(y)
    }
)

// P3Q4
useEffect (
    function() {
        var tab = [vP3Q4R1, vP3Q4R2, vP3Q4R3, vP3Q4R4, vP3Q4R5, vP3Q4R6, vP3Q4R7, vP3Q4R8]
        var x
        var y
        
        for (let i = 0; i < 8; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P3Q4R1 + tab[1]*P3Q4R2 + tab[2]*P3Q4R3 + tab[3]*P3Q4R4 + tab[4]*P3Q4R5 + tab[5]*P3Q4R6 + tab[6]*P3Q4R7 + tab[7]*P3Q4R8

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]+tab[1]+tab[2]+tab[3]+tab[4]+tab[5]+tab[6]+tab[7]
        // IF ici si Pmax
        if (x<261) {
            setMaxP3Q4(x)  
        }
        if (x>260) {
            setMaxP3Q4(260)  
        }

        if (y<261) {
            setPointP3Q4(y)  
        }
        if (y>260) {
            setPointP3Q4(260)  
        }

    }
)

// P4Q0
// Point bonus, pas de calule du nombre maximal de point possible de cette question
useEffect (
    function() {
        var y


        y=vP4Q0R1*P4Q0R1 + vP4Q0R2*P4Q0R2 + vP4Q0R3*P4Q0R3 + vP4Q0R4*P4Q0R4

        setPointP4Q0(y)
    }
)

// P4Q1
useEffect (
    function() {
        var tab = [vP4Q1R1, vP4Q1R2, vP4Q1R3]
        var x
        var y
        
        for (let i = 0; i < 4; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P4Q1R1 + tab[1]*P4Q1R2 + tab[2]*P4Q1R3

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP4Q1(0)
        // QUESTION ANNULE DANS CETTE VERSION
        setPointP4Q1(y)
    }
)

// P4Q2
useEffect (
    function() {
        var tab = [vP4Q2R1, vP4Q2R2, vP4Q2R3, vP4Q2R4, vP4Q2R5, vP4Q2R6, vP4Q2R7, vP4Q2R8, vP4Q2R9]
        var x
        var y
        
        for (let i = 0; i < 9; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P4Q2R1 + tab[1]*P4Q2R2 + tab[2]*P4Q2R3 + tab[3]*P4Q2R4 + tab[4]*P4Q2R5 + tab[5]*P4Q2R6 + tab[6]*P4Q2R7 + tab[7]*P4Q2R8 + tab[8]*P4Q2R9

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]+tab[1]+tab[2]+tab[3]+tab[4]+tab[5]+tab[6]+tab[7]+tab[8]
        // IF ici si Pmax
        if (x<51) {
            setMaxP4Q2(x)  
        }
        if (x>50) {
            setMaxP4Q2(50)  
        }

        if (y<51) {
            setPointP4Q2(y)  
        }
        if (y>50) {
            setPointP4Q2(50)  
        }

    }
)

// P4Q3
useEffect (
    function() {
        var tab = [vP4Q3R1, vP4Q3R2, vP4Q3R3]
        var x
        var y
        
        for (let i = 0; i < 3; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P4Q3R1 + tab[1]*P4Q3R2 + tab[2]*P4Q3R3

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]

        // IF ici si Pmax
        setMaxP4Q3(x)
        setPointP4Q3(y)
    }
)

// P4Q4
useEffect (
    function() {
        var tab = [vP4Q4R1, vP4Q4R2, vP4Q4R3, vP4Q4R4, vP4Q4R5, vP4Q4R6, vP4Q4R7]
        var x
        var y
        
        for (let i = 0; i < 7; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P4Q4R1 + tab[1]*P4Q4R2 + tab[2]*P4Q4R3 + tab[3]*P4Q4R4 + tab[4]*P4Q4R5 + tab[5]*P4Q4R6 + tab[6]*P4Q4R7

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]+tab[1]+tab[2]+tab[3]+tab[4]+tab[5]+tab[6]
        
        // IF ici si Pmax
        if (x<71) {
            setMaxP4Q4(x)  
        }
        if (x>70) {
            setMaxP4Q4(70)  
        }


        if (y<71) {
            setPointP4Q4(y)  
        }
        if (y>70) {
            setPointP4Q4(70)  
        }

    }
)

// P4Q5
useEffect (

    
    function() {


        setP4Q5Rinput(parseInt(P4Q5Rinput))

        if (P4Q5Rinput == 0 | P4Q5Rinput== "") {
            setPointP4Q5(0)
        }

        if (P4Q5Rinput > 0 & P4Q5Rinput <41){
            setPointP4Q5(P4Q5Rinput)
        }

        if (P4Q5Rinput >40){
            setPointP4Q5(40)
        }

        setMaxP4Q5(40)

    }

)

// P4Q6
useEffect (
    function() {
        var tab = [vP4Q6R1, vP4Q6R2, vP4Q6R3, vP4Q6R4]
        var x
        var y
        
        for (let i = 0; i < 4; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P4Q6R1 + tab[1]*P4Q6R2 + tab[2]*P4Q6R3 + tab[3]*P4Q6R4

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP4Q6(x)
        setPointP4Q6(y)
    }
)

// P4Q7
useEffect (
    function() {
        var tab = [vP4Q7R1, vP4Q7R2]
        var x
        var y
        
        for (let i = 0; i < 2; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P4Q7R1 + tab[1]*P4Q7R2

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP4Q7(x)
        setPointP4Q7(y)
    }
)

// P4Q8
useEffect (
    function() {
        var tab = [vP4Q8R1, vP4Q8R2, vP4Q8R3]
        var x
        var y
        
        for (let i = 0; i < 3; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P4Q8R1 + tab[1]*P4Q8R2 + tab[2]*P4Q8R3

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP4Q8(0)
        // QUESTION SUPPRIME DANS CETTE VERSION
        setPointP4Q8(y)
    }
)

// P4Q910
useEffect (
    function() {
        var tab = [vP4Q9R1, vP4Q9R2, vP4Q9R3, vP4Q10R1, vP4Q10R2, vP4Q10R3]
        var x
        var y
        var p

        var a=0
        var b=0
        var c=0
        
        
        for (let i = 0; i < 6; i=i+1) {
            if (typeof tab[i] === 'string') {
                tab.splice(i, 1, 0);
            }  
          }

        y=tab[0]*P4Q9R1 + tab[1]*P4Q9R2 + tab[2]*P4Q9R3 + tab[3]*P4Q10R1 + tab[4]*P4Q10R2 + tab[5]*P4Q10R3

        // tab.sort(); 

        const sortDesc = (a, b) => b - a;
        tab.sort(sortDesc);

        x=tab[0]
        // IF ici si Pmax
        setMaxP4Q910(110)
        // MAX = 150 mais 40 POINTS BONUS
        setPointP4Q910(y)

        p=P3Q1R1+P3Q1R2+P3Q1R3+P3Q1R4+P3Q1R5+P3Q1R6+P3Q1R7+P3Q1R8+P3Q1R9+P3Q1R10
        console.log(p)

        if(P4Q9R1==0) {
            setP4Q10R1(0)
            setP4Q10R2(0)
            setP4Q10R3(0)
            setP4Q10texte("")
            setP4Q10texteTraduit("")
        }




        if((P4Q9R1==1) & (P3Q4R2==1 | P3Q4R3==1)&(P3Q1R4==1 | P3Q1R5==1 | P3Q1R6==1 | P3Q1R7==1 | P3Q1R8==1 | P3Q1R9==1 | P3Q1R10==1)) {
            setP4Q10R1(0)
            setP4Q10R2(1)
            setP4Q10R3(0)
            setP4Q10texte("MOYENNE")
            a=1
        }

        if((P4Q9R1==1) & (P3Q4R1==1) & (P3Q4R4==1|P3Q4R5==1)&(p>1)) {
            setP4Q10R1(0)
            setP4Q10R2(1)
            setP4Q10R3(0)
            setP4Q10texte("MOYENNE")
            b=1
        }

        if((P4Q9R1==1) & (P3Q4R2==1 | P3Q4R3==1)&(P3Q1R1==1 | P3Q1R2==1 | P3Q1R3==1)) {
            setP4Q10R1(1)
            setP4Q10R2(0)
            setP4Q10R3(0)
            setP4Q10texte("ELEVEE")
            c=1
        }

        if (P4Q9R1==1 & a==0 & b==0 & c==0){
            setP4Q10R1(0)
            setP4Q10R2(0)
            setP4Q10R3(1)
            setP4Q10texte("FAIBLE")
        }

        if (P4Q10texte=="FAIBLE"){
            setP4Q10texteTraduit(" LOW")
        }

        
        if (P4Q10texte=="MOYENNE"){
            setP4Q10texteTraduit(" MEDIUM")
        }


        if (P4Q10texte=="ELEVEE"){
            setP4Q10texteTraduit(" HIGH")
        }

        console.log(a)
        console.log(b)
        console.log(c)
        console.log(P4Q10R3)

        


    }
)

// CALCULE POINT TOTALE

//P1
useEffect (
    function() {
        var y
        var x
        var t
        y = PointP1Q1+PointP1Q2+PointP1Q3+PointP1Q4+PointP1Q4b+PointP1Q5+PointP1Q6+PointP1Criticite
        x = MaxP1Q1+MaxP1Q2+MaxP1Q3+MaxP1Q4+MaxP1Q4b+MaxP1Q5+MaxP1Q6+MaxP1Criticite

        if(y<0){
            setPointPartie1(0)
        }

        if(y>=0){
            setPointPartie1(y)
        }

        setMaxPartie1(x)

        t = (PointPartie1)/MaxPartie1*20
        t = t.toFixed(1)
        setPointsur20Partie1(t)
    }
    
)

//P2
useEffect (
    function() {
        var y
        var x
        var t
        y = PointP2Q1+PointP2Q2+PointP2Q3+PointP2Q4+PointP2Q5
        x = MaxP2Q1+MaxP2Q2+MaxP2Q3+MaxP2Q4+MaxP2Q5


        if(y<0){
            setPointPartie2(0)
        }

        if(y>=0){
            setPointPartie2(y)
        }

        setMaxPartie2(x)

        t = PointPartie2/MaxPartie2*20
        t = t.toFixed(1)
        setPointsur20Partie2(t)
    }
    
)

//P3
useEffect (
    function() {
        var y
        var x
        var t
        y = PointP3Q1+PointP3Q2+PointP3Q3+PointP3Q4
        x = MaxP3Q1+MaxP3Q2+MaxP3Q3+MaxP3Q4


        if(y<0){
            setPointPartie3(0)
        }

        if(y>=0){
            setPointPartie3(y)
        }

        setMaxPartie3(x)

        t = PointPartie3/MaxPartie1*20
        t = t.toFixed(1)
        setPointsur20Partie3(t)
    }
    
)


//P4
useEffect (
    function() {
        var y
        var x
        var t
        var z
        y = PointP4Q0+PointP4Q1+PointP4Q2+PointP4Q3+PointP4Q4+PointP4Q5+PointP4Q6+PointP4Q7+PointP4Q8+PointP4Q910
        x = MaxP4Q1+MaxP4Q2+MaxP4Q3+MaxP4Q4+MaxP4Q5+MaxP4Q6+MaxP4Q7+MaxP4Q8+MaxP4Q910
        // SI réponse P4Q1R4 == oui alors -30% sur le score globale de la partie 4


        if (y>x) {
            z=x
        }

        if (y<=x) {

            if(y<0){
                z=0
            }

            if(y>=0){
                z=y
            }
            
        }

        if (P4Q1R4===1){
            z = z*(1+(vP4Q1R4/100))
        }

        setPointPartie4(parseInt(z))

        setMaxPartie4(x)

        t = PointPartie4/MaxPartie4*20
        t = t.toFixed(1)
        setPointsur20Partie4(t)
    }
    
)

// POINT TOT & MAX TOT

useEffect (
    function() {

        var x = MaxPartie1 + MaxPartie2 + MaxPartie3 + MaxPartie4
        setPointMax(x)

        var y = PointPartie1 + PointPartie2 + PointPartie3 + PointPartie4
        setPointTotal(y)

        var t

        t = PointTotal/PointMax*20
        t = t.toFixed(1)
        setPointsur20Total(t)

    
    }
    
)

// EXCEL FONCTION

useEffect (
    function() {
        var x
        x =  date + "," + P0nomsolution + "," + PointTotal + "," + PointMax +  "," + PointPartie1 + "," + PointPartie2 +  "," + PointPartie3 + "," + PointPartie4 +  "," + PointP1Q1 + "," + P1Q1R1 +  "," + P1Q1R2 + "," + P1Q1R3 +  "," + P1Q1R4 + "," + P1Q1R5 +  "," + P1Q1R6 + "," + P1Q1R7 +  "," + P1Q1R8 + "," + P1Q1R9 +  "," + PointP1Q2 + "," + P1Q2R1 +  "," + P1Q2R2 + "," + P1Q2R3 +  "," + P1Q2R4 + "," + P1Q2R5 +  "," + P1Q2R6 + "," + P1Q2R7 +  "," + P1Q2R8 + "," + P1Q2R9 +  "," + P1Q2R10 + "," + P1Q2R11 +  "," + P1Q2R12 + "," + P1Q2R13 +  "," + P1Q2R14 + "," + P1Q2R15 +  "," + P1Q2R16 + "," + P1Q2R17 +  "," + P1Q2R19 + "," + P1Q2R20 + "," + P1Q2R21 + "," + P1Q2R18 + "," + PointP1Q3 +  "," + P1Q3R1 + "," + P1Q3R2 +  "," + P1Q3R3 + "," + PointP1Q6 + "," + P1Q6R1 + "," + P1Q6R2 + "," + P1Q6R3 + "," + PointP1Q4 +  "," + P1Q4R1 + "," + P1Q4R2 +  "," + P1Q4R3 + "," + P1Q4R4 + "," + P1Q4c1R1 + "," + P1Q4c1R2 + "," + P1Q4c2R1 + "," + P1Q4c2R2 + "," + PointP1Q5 +  "," + P1Q5R1 + "," + P1Q5R2 +  "," + P1Q5R3 + "," + P1Q5R4 +  "," + P1Q5R5 + "," + P1Q5R6 +  "," + PointP1Criticite + "," + PointP2Q1 + "," + P2Q1R1 +  "," + P2Q1R2 + "," + P2Q1R3 +  "," + PointP2Q2 + "," + P2Q2Rinput +  "," + PointP2Q3 + "," + P2Q3R1 +  "," + P2Q3R2 + "," + PointP2Q4 +  "," + P2Q4R1 + "," + P2Q4R2 +  "," + P2Q4R3 + "," + P2Q4R4 + "," + P2Q4R5 +  "," + PointP2Q5 + "," + P2Q5R1 +  "," + P2Q5R2 + "," + P2Q5R3 +  "," + P2Q5R4 + "," + PointP3Q1 +  "," + P3Q1R1 + "," + P3Q1R2 +  "," + P3Q1R3 + "," + P3Q1R4 +  "," + P3Q1R5 + "," + P3Q1R6 +  "," + P3Q1R7 + "," + P3Q1R8 +  "," + P3Q1R9 + "," + P3Q1R10 +  "," + P3Q1R11 + "," + PointP3Q2 +  "," + P3Q2R1 + "," + P3Q2R2 +  "," + P3Q2R3 + "," + P3Q2R4 +  "," + PointP3Q3 + "," + P3Q3R1 +  "," + P3Q3R2 + "," + PointP3Q4 +  "," + P3Q4R1 + "," + P3Q4R2 +  "," + P3Q4R3 + "," + P3Q4R4 +  "," + P3Q4R5 + "," + P3Q4R6 +  "," + P3Q4R7 + "," + P3Q4R8 +  "," + PointP4Q0 + "," + P4Q0R1 + "," + P4Q0R2 + "," + P4Q0R3 + "," + P4Q0R4 + "," + PointP4Q2 +  "," + P4Q2R1 + "," + P4Q2R2 +  "," + P4Q2R3 + "," + P4Q2R4 +  "," + P4Q2R5 + "," + P4Q2R6 +  "," + P4Q2R7 + "," + P4Q2R8 +  "," + P4Q2R9 + "," + PointP4Q3 +  "," + P4Q3R1 + "," + P4Q3R2 +  "," + P4Q3R3 + "," + PointP4Q4 +  "," + P4Q4R1 + "," + P4Q4R2 +  "," + P4Q4R3 + "," + P4Q4R4 +  "," + P4Q4R5 + "," + P4Q4R6 + "," + P4Q4R7 + "," + PointP4Q5 + "," + P4Q5Rinput +  "," + PointP4Q6 + "," + P4Q6R1 +  "," + P4Q6R2 + "," + P4Q6R3 +  "," + P4Q6R4 + "," + PointP4Q7  +  "," + P4Q7R1 + "," + P4Q7R2 +  "," + PointP4Q910 + "," + P4Q9R1 +  "," + P4Q9R2 + "," + P4Q9R3 +  "," + P4Q10R1 + "," + P4Q10R2 +  "," + P4Q10R3 + "," + ',' + P4Q11R1 + "," + P4Q11R2 + "," + P4Q11R3 + "," + P4Q11R4 + "," + P4Q11R5 + "," + P4Q11R6 + "," + "," + P4Q12R1 + "," + P4Q12R2 + "," + P4Q12R3 + "," + P4Q12R4 + "," + P4Q12R5 + "," + P4Q12R6 + "," + P0mail
        setExcel(x)
    
    }
    
)

// FONCTION LISTE 

// CALCULE SCORE & ENVOI FIREBASE


const onClickbCalculeScore =function() {

    setP0nomsolutionaff(P0nomsolution)

    if(Eliminatoire===0){
        setPointPartie1aff(PointPartie1)
        setPointPartie2aff(PointPartie2)
        setPointPartie3aff(PointPartie3)
        setPointPartie4aff(PointPartie4)
        setPointTotalaff(PointTotal)


        setPointsur20Partie1aff(Pointsur20Partie1)
        setPointsur20Partie2aff(Pointsur20Partie2)
        setPointsur20Partie3aff(Pointsur20Partie3)
        setPointsur20Partie4aff(Pointsur20Partie4)
        setPointsur20Totalaff(Pointsur20Total)

        setInfopositionscoreaff(Infopositionscore)
    }

    setEliminatoireaff(0)
    setDisplayaff('none')
    if (Eliminatoire===1){
        setEliminatoireaff(Eliminatoire)
        setDisplayaff('block')
    }

    setItemnegatifaff(0)
    setDisplaynegatifaff('none')
    if (Itemnegatif===1){
        setItemnegatifaff(Itemnegatif)
        setDisplaynegatifaff('block')
    }



    tutorialsRef.doc(Date.now().toString()).set({
        a0_EXCEL : Excel,
        a0a : "DATA modele INT INVES v03.07.23 - v1 INVESTISSEUR INT",
        a0c_INES : "ModeINTERNATIONAL",
        a1_Nom: P0nomsolution


      })
      .then(function(docRef) {
          console.log("Tutorial created with ID: ", docRef.id);
      })
      .catch(function(error) {
          console.error("Error adding Tutorial: ", error);
      });;



}






return (
<div className="App">

<div className='FR'>
<button className={"btnFR"} onClick={() =>history.push('/')}>French version</button>
<br/>
<button className={"btnFR"} onClick={() =>history.push('/int')}>Other countrie's version</button>
<br/>

</div>

    <div className='detail'>
        <button className={"btnFR"} onClick={() =>history.push('/infoint')}>MDS score information</button>
    </div>            

<div className="Header">




{/* <img src={Bandeau} width="100" height="50" /> */}



<div className='logo'>
{/* <img src={NvxBandeauINES} width="283" height="87" /> */}
</div>



{/* <span className='logoines'> <img src={Logo} width="131" height="80" /> </span>  */}

{/* <a
              href="/bio"
              className="bio"
              >
                <div>
                    <p className="textlien">Détails de l’application</p>
                </div>
            </a> */}

    {/* <>
    <Navbar bg="dark" variant="dark">
    <Container> */}

    {/* <Navbar.Brand href="/oncologie">CHOISIR UNE AUTRE CHIMIO</Navbar.Brand> */}

    {/* <p className='Headertexte'>Score d'évaluation des solutions en e-santé</p> */}
    {/* </Container>
    </Navbar>
    </> */}



</div>  





<div className="droitegauche">

    {/* PARTIE GAUCHE */}

    <div className="gauche">


        <div className="gaucherectangle">



            <div className="accordion"> 

            <div className='FRmobile'>
                <button className={"btnFRmobile"} onClick={() =>history.push('/')}>French version</button>
                <br/>
                <button className={"btnFRmobile"} onClick={() =>history.push('/int')}>Other countrie's version</button>
                <br/><br/>
                <button className={"btnFRmobile"} onClick={() =>history.push('/infoint')}>MDS score information</button>


                <p></p>
            </div>  

<p className='titrepartie'>APPLICATION INFORMATION</p>


                        <div className="gauchesection">
                            <div className="gauche100">
                                    <Boutonexcluinput
                                titre={"Name of the evaluated solution: (if not defined, write ND)"}
                                modeactivation={false}
                                nombredebouton={0}
                                variable={P0nomsolution}
                                setParentvariable={setP0nomsolution}
                                reclicbouton={""}
                                placeholderinputtext={""}
                                typeinput={"texte"}
                                />
                            </div>
                        </div>

                        <div className="gauchesection">
                            <div className="gauche100">
                                    <Boutonexcluinput
                                titre={"Contact email address:"}
                                modeactivation={false}
                                nombredebouton={0}
                                variable={P0mail}
                                setParentvariable={setP0mail}
                                reclicbouton={""}
                                placeholderinputtext={""}
                                typeinput={"texte"}
                                />
                            </div>
                        </div>


                        <div className="gauchesection">
                            <div className="gauche100">
                                <QuestionAvecExclusion
                                Libellequestion={"Field of application (2 answers maximum)" }
                                nombredebouton={9}
                                Nbsitemmax={2}
                                VariableExlu={P1Q1R1}
                                Statut1={P1Q1R1}
                                Statut2={P1Q1R2}
                                Statut3={P1Q1R3}
                                Statut4={P1Q1R4}
                                Statut5={P1Q1R5}
                                Statut6={P1Q1R6}
                                Statut7={P1Q1R7}
                                Statut8={P1Q1R8}
                                Statut9={P1Q1R9}
                                textproposition1={"Wellness area only" }
                                setParentStatut1={setP1Q1R1}
                                textproposition2={"Medical field: Prevention" }
                                setParentStatut2={setP1Q1R2}
                                textproposition3={"Medical field: Early detection/identification" }
                                setParentStatut3={setP1Q1R3}
                                textproposition4={"Medical field: Decision support" }
                                setParentStatut4={setP1Q1R4}
                                textproposition5={"Medical field: Treatment aid/compliance/toxicity reduction" }
                                setParentStatut5={setP1Q1R5}
                                textproposition6={"Medical field: Direct therapeutic solution (VR for example)" }
                                setParentStatut6={setP1Q1R6}
                                textproposition7={"Medical field: Patient triage" }
                                setParentStatut7={setP1Q1R7}
                                textproposition8={"Medical field: Emergency department decongestion" }
                                setParentStatut8={setP1Q1R8}
                                textproposition9={"Medical field: Other" }
                                setParentStatut9={setP1Q1R9}
                                />        
                            </div>
                        </div>

                        <div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                Libellequestion={"Which medical domains are concerned by the application? (Max 2 answers)" }
                                nombredebouton={21}
                                Nbsitemmax={2}
                                Statut13={P1Q2R1}
                                Statut2={P1Q2R2}
                                Statut11={P1Q2R3}
                                Statut16={P1Q2R4}
                                Statut15={P1Q2R5}
                                Statut4={P1Q2R6}
                                Statut7={P1Q2R7}
                                Statut17={P1Q2R8}
                                Statut10={P1Q2R9}
                                Statut20={P1Q2R10}
                                Statut18={P1Q2R11}
                                Statut8={P1Q2R12}
                                Statut5={P1Q2R13}
                                Statut3={P1Q2R14}
                                Statut1={P1Q2R15}
                                Statut19={P1Q2R16}
                                Statut9={P1Q2R17}
                                Statut6={P1Q2R19}
                                Statut12={P1Q2R20}
                                Statut14={P1Q2R21}
                                Statut21={P1Q2R18}
                                textproposition13={"Oncology" }
                                setParentStatut13={setP1Q2R1}
                                textproposition2={"Cardiology" }
                                setParentStatut2={setP1Q2R2}
                                textproposition11={"Neurology" }
                                setParentStatut11={setP1Q2R3}
                                textproposition16={"Psychiatry" }
                                setParentStatut16={setP1Q2R4}
                                textproposition15={ "Pediatrics" }
                                setParentStatut15={setP1Q2R5}
                                textproposition4={"Diabetology" }
                                setParentStatut4={setP1Q2R6}
                                textproposition7={"Gynecology" }
                                setParentStatut7={setP1Q2R7}
                                textproposition17={"Pulmonology" }
                                setParentStatut17={setP1Q2R8}
                                textproposition10={"Nephrology" }
                                setParentStatut10={setP1Q2R9}
                                textproposition20={"Urology/Andrology" }
                                setParentStatut20={setP1Q2R10}
                                textproposition18={"Rheumatology" }
                                setParentStatut18={setP1Q2R11}
                                textproposition8={"Head and neck" }
                                setParentStatut8={setP1Q2R12}
                                textproposition5={"Gastroenterology" }
                                setParentStatut5={setP1Q2R13}
                                textproposition3={"Dermatology" }
                                setParentStatut3={setP1Q2R14}
                                textproposition1={"Autoimmune disease/Internal medicine/Infectiology" }
                                setParentStatut1={setP1Q2R15}
                                textproposition19={"Surgery" }
                                setParentStatut19={setP1Q2R16}
                                textproposition9={"Imagery" }
                                setParentStatut9={setP1Q2R17}
                                textproposition6={"Geriatrics" }
                                setParentStatut6={setP1Q2R19}
                                textproposition12={"Nutrition" }
                                setParentStatut12={setP1Q2R20}
                                textproposition14={"Ophthalmology" }
                                setParentStatut14={setP1Q2R21}
                                textproposition21={"Other (emergency medicine, general medicine, pain management, biology...)" }
                                setParentStatut21={setP1Q2R18}

                                />        
                            </div>
                        </div>  

                        <div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                Libellequestion={"Is the solution classified in accordance with proposed context of use and latest guidelines within the jurisdiction (for example class IIa CE marked in Europe for remote monitoring device…)" }
                                nombredebouton={3}
                                Nbsitemmax={1}
                                Statut1={P1Q3R1}
                                Statut2={P1Q3R2}
                                Statut3={P1Q3R3}
                                textproposition1={"YES" }
                                setParentStatut1={setP1Q3R1}
                                textproposition2={"NO and it is not applicable" }
                                setParentStatut2={setP1Q3R2}
                                textproposition3={"NO and it should be" }
                                setParentStatut3={setP1Q3R3}
                                />        
                            </div>
                        </div>  

                        <div className="gauchesection">
                            <div className="gauche100">
                            <Question
                                Libellequestion={"Integration of the solution to the Electronic Medical Record" }
                                nombredebouton={3}
                                Nbsitemmax={1}
                                Statut1={P1Q6R1}
                                Statut2={P1Q6R2}
                                Statut3={P1Q6R3}
                                textproposition1={"YES" }
                                setParentStatut1={setP1Q6R1}
                                textproposition2={"NO, not applicable" }
                                setParentStatut2={setP1Q6R2}
                                textproposition3={"NO but it should be/work in progress" }
                                setParentStatut3={setP1Q6R3}
                                />      
                            </div>                            
                        </div>


                        <div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                Libellequestion={"Does your solution use an algorithm? (One answer only)" }
                                nombredebouton={4}
                                Nbsitemmax={1}
                                Statut1={P1Q4R1}
                                Statut2={P1Q4R2}
                                Statut3={P1Q4R3}
                                Statut4={P1Q4R4}
                                textproposition1={"Not applicable" }
                                setParentStatut1={setP1Q4R1}
                                textproposition2={"Yes: boolean, common rules, logistic regression…" }
                                setParentStatut2={setP1Q4R2}
                                textproposition3={"Yes: Black Box AI" }
                                setParentStatut3={setP1Q4R3}
                                textproposition4={"Yes: intelligible AI" }
                                setParentStatut4={setP1Q4R4}
                                />        
                            </div>
                        </div>

                        {/* Question bonus conditionnelles si IA non intelligible */}

                        {P1Q4R3==1 ? <div className="gauchesection"> <div className="gauche100"> <Question Libellequestion={"Sensitivity is equal to or greater than 75%" } nombredebouton={2} Nbsitemmax={1} Statut1={P1Q4c1R1} Statut2={P1Q4c1R2} textproposition1={"YES >= 75%" } setParentStatut1={setP1Q4c1R1} textproposition2={"NO <75%" } setParentStatut2={setP1Q4c1R2} /> </div></div> : null}

                        {P1Q4R3==1 ? <div className="gauchesection"> <div className="gauche100"> <Question Libellequestion={"Are the elements of interpretability, i.e. the parameters (input variable, weightings, etc.) influencing decision-making visible to the user?" } nombredebouton={2} Nbsitemmax={1} Statut1={P1Q4c2R1} Statut2={P1Q4c2R2} textproposition1={"YES" } setParentStatut1={setP1Q4c2R1} textproposition2={"NO" } setParentStatut2={setP1Q4c2R2} /> </div></div> : null}

                        {/* fin des questions bonus  */}



                        <div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                Libellequestion={"Interaction between the solution and the user? (One answer only):" }
                                nombredebouton={6}
                                Nbsitemmax={1}
                                Statut2={P1Q5R1}
                                Statut3={P1Q5R2}
                                Statut4={P1Q5R3}
                                Statut5={P1Q5R4}
                                Statut6={P1Q5R5}
                                Statut1={P1Q5R6}
                                textproposition2={"No patient information" }
                                setParentStatut2={setP1Q5R1}
                                textproposition3={"General informations (not personalized)" }
                                setParentStatut3={setP1Q5R2}
                                textproposition4={"Alerts to the patient who manages it himself without teleconsultation access" }
                                setParentStatut4={setP1Q5R3}
                                textproposition5={"The patient receives alerts and can request a teleconsultation" }
                                setParentStatut5={setP1Q5R4}
                                textproposition6={"The patient is monitored remotely by a healthcare professional" }
                                setParentStatut6={setP1Q5R5}
                                textproposition1={"Not applicable" }
                                setParentStatut1={setP1Q5R6}
                                />        
                            </div>
                        </div>                        

                        {/* </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion> */}
            </div>


            <div className='accordion'>
            {/* <Accordion defaultActiveKey="0">
                    <Card>
                        <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="0">
                            <p className="titreacc">INFORMATION SUR LA CIBLE DE LA SOLUTION</p>
                        </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="0">
                        <Card.Body> */}

<p className='titrepartie'>INFORMATION ON THE TARGET OF THE SOLUTION</p>

                        

                        <div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                Libellequestion={"What is the target age of the patient population? (1 to 3 possible answer(s))" }
                                nombredebouton={3}
                                Nbsitemmax={3}
                                Statut1={P2Q1R1}
                                Statut2={P2Q1R2}
                                Statut3={P2Q1R3}
                                textproposition1={"From 18 to 64 years old" }
                                setParentStatut1={setP2Q1R1}
                                textproposition2={"65 and over" }
                                setParentStatut2={setP2Q1R2}
                                textproposition3={"Pediatrics (under 18)" }
                                setParentStatut3={setP2Q1R3}
                                />        
                            </div>
                        </div>

                        <div className="gauchesection">
                            <div className="gauche100">
                            <Boutonexcluinput
                                titre={"What is the size of the target (per year in your country)"}
                                modeactivation={false}
                                nombredebouton={0}
                                variable={P2Q2Rinput}
                                setParentvariable={setP2Q2Rinput}
                                reclicbouton={""}
                                placeholderinputtext={"enter a number" }
                                typeinput={"number"}
                                />
                            </div>
                        </div>

                    <div className="gauchesection">
                        <div className="gauche100">
                            <Question
                            Libellequestion={"Is the solution transferable to other countries?" }
                            nombredebouton={2}
                            Nbsitemmax={1}
                            Statut1={P2Q3R1}
                            Statut2={P2Q3R2}
                            textproposition1={"YES" }
                            setParentStatut1={setP2Q3R1}
                            textproposition2={"NO" }
                            setParentStatut2={setP2Q3R2}
                            />        
                        </div>
                    </div>                     


                    <div className="gauchesection">
                        <div className="gauche100">
                            <Question
                            Libellequestion={"How many patients were involved in the development of the solution (including inclusions in studies)? (One answer only):" }
                            nombredebouton={5}
                            Nbsitemmax={1}
                            Statut1={P2Q4R1}
                            Statut2={P2Q4R2}
                            Statut3={P2Q4R3}
                            Statut4={P2Q4R4}
                            Statut5={P2Q4R5}
                            textproposition1={"Development with patients/patient community/beta testers: > 500" }
                            setParentStatut1={setP2Q4R1}
                            textproposition2={"Development with patients/patient community/beta testers: between 50 and 499" }
                            setParentStatut2={setP2Q4R2}
                            textproposition3={"Development with patients/patient community/beta testers: <50" }
                            setParentStatut3={setP2Q4R3}
                            textproposition4={"No patient involved in development for patient-facing software" }
                            setParentStatut4={setP2Q4R4}
                            textproposition5={"No patient involved in the development but business software for the healthcare professional (automatic analysis of imaging, ECG, etc.)" }
                            setParentStatut5={setP2Q4R5}
                            />        
                        </div>
                    </div>

                    <div className="gauchesection">
                        <div className="gauche100">
                            <Question
                            Libellequestion={"How does the solution impact professional workflow at the hospital? (One answer only)" }
                            nombredebouton={4}
                            Nbsitemmax={1}
                            Statut1={P2Q5R1}
                            Statut2={P2Q5R2}
                            Statut4={P2Q5R3}
                            Statut3={P2Q5R4}
                            textproposition1={"No impact" }
                            setParentStatut1={setP2Q5R1}
                            textproposition2={"The solution simplifies workflow" }
                            setParentStatut2={setP2Q5R2}
                            textproposition4={"The solution adds to workflow with no possibility of financing" }
                            setParentStatut4={setP2Q5R3}
                            textproposition3={"The solution adds to workflow with possibility of financing through a reimbursement code or act" }
                            setParentStatut3={setP2Q5R4}
                            />        
                        </div>
                    </div>
{/* 
                        </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion> */}
            </div>

            <div className='accordion'>
{/* <Accordion defaultActiveKey="0">
        <Card>
            <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey="0">
                <p className="titreacc">INFORMATION SUR L'EVALUATION CLINIQUE DE LA SOLUTION</p>
            </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
            <Card.Body> */}

<p className='titrepartie'>INFORMATION ON THE CLINICAL EVALUATION OF THE SOLUTION</p>

            <div className="gauchesection">
                <div className="gauche100">
                    <Question
                    Libellequestion={"What is (are) the validated outcome(s) for this solution? (max 3 answers)" }
                    nombredebouton={11}
                    Nbsitemmax={3}
                    Statut1={P3Q1R1}
                    Statut2={P3Q1R2}
                    Statut3={P3Q1R3}
                    Statut4={P3Q1R4}
                    Statut5={P3Q1R5}
                    Statut6={P3Q1R6}
                    Statut7={P3Q1R7}
                    Statut8={P3Q1R8}
                    Statut9={P3Q1R9}
                    Statut10={P3Q1R10}
                    Statut11={P3Q1R11}
                    textproposition1={"Survival" }
                    setParentStatut1={setP3Q1R1}
                    textproposition2={"Quality of life" }
                    setParentStatut2={setP3Q1R2}
                    textproposition3={"Reduction in severity/severity of a condition/symptom" }
                    setParentStatut3={setP3Q1R3}
                    textproposition4={"Early diagnosis gain" }
                    setParentStatut4={setP3Q1R4}
                    textproposition5={"Primary/secondary/tertiary prevention" }
                    setParentStatut5={setP3Q1R5}
                    textproposition6={"Improved access to care" }
                    setParentStatut6={setP3Q1R6}
                    textproposition7={"Medico-economic benefit" }
                    setParentStatut7={setP3Q1R7}
                    textproposition8={"Less toxicity than reference" }
                    setParentStatut8={setP3Q1R8}
                    textproposition9={"Improved treatment compliance" }
                    setParentStatut9={setP3Q1R9}
                    textproposition10={"Reduction of emergencies" }
                    setParentStatut10={setP3Q1R10}
                    textproposition11={"User satisfaction" }
                    setParentStatut11={setP3Q1R11}
                    />        
                </div>                            
            </div>

            <div className="gauchesection">
                <div className="gauche100">
                    <Question
                    Libellequestion={"Opinion of 1 or 2 medical specialists on the theoretical clinical relevance of the solution? (only one answer)" }
                    nombredebouton={4}
                    Nbsitemmax={1}
                    Statut1={P3Q2R1}
                    Statut2={P3Q2R2}
                    Statut3={P3Q2R3}
                    Statut4={P3Q2R4}
                    textproposition1={"No opinion taken" }
                    setParentStatut1={setP3Q2R1}
                    textproposition2={"Opinion taken: low relevance" }
                    setParentStatut2={setP3Q2R2}
                    textproposition3={"Opinion taken: moderate relevance" }
                    setParentStatut3={setP3Q2R3}
                    textproposition4={"Opinion taken: major relevance" }
                    setParentStatut4={setP3Q2R4}
                    />        
                </div>
            </div>

            <div className="gauchesection">
                <div className="gauche100">
                    <Question
                    Libellequestion={"Support/partnership with medical/scientific society (one answer only)" }
                    nombredebouton={2}
                    Nbsitemmax={1}
                    Statut1={P3Q3R1}
                    Statut2={P3Q3R2}
                    textproposition1={"YES" }
                    setParentStatut1={setP3Q3R1}
                    textproposition2={"NO" }
                    setParentStatut2={setP3Q3R2}
                    />        
                </div>
            </div>

            <div className="gauchesection">
                <div className="gauche100">
                    <Question
                    Libellequestion={"How has the solution been validated clinically?" }
                    nombredebouton={8}
                    Nbsitemmax={8}
                    Statut1={P3Q4R1}
                    Statut2={P3Q4R2}
                    Statut3={P3Q4R3}
                    Statut4={P3Q4R4}
                    Statut5={P3Q4R5}
                    Statut6={P3Q4R6}
                    Statut7={P3Q4R7}
                    Statut8={P3Q4R8}
                    textproposition1={"Applications of national/international recommendations in the solution or international recommendations" }
                    setParentStatut1={setP3Q4R1}
                    textproposition2={"1 randomized trial which included more than 200 patients or a meta-analysis" }
                    setParentStatut2={setP3Q4R2}
                    textproposition3={"1 randomized trial which included less than 200 patients" }
                    setParentStatut3={setP3Q4R3}
                    textproposition4={"1 prospective real-life study >= 200 patients versus non-randomized control arm (historical comparison, data, etc.)" }
                    setParentStatut4={setP3Q4R4}
                    textproposition5={"1 prospective study >=200 patients (not in real life) versus non-randomized control arm" }
                    setParentStatut5={setP3Q4R5}
                    textproposition6={"Retrospective study > 300 evaluable patients" }
                    setParentStatut6={setP3Q4R6}
                    textproposition7={"Validated by experts" }
                    setParentStatut7={setP3Q4R7}
                    textproposition8={"No data available" }
                    setParentStatut8={setP3Q4R8}
                    />        
                </div>
            </div>

            {/* </Card.Body>
            </Accordion.Collapse>
        </Card>
    </Accordion> */}
</div>  

            <div className='accordionfinal'>
            {/* <Accordion defaultActiveKey="0">
                    <Card>
                        <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="0">
                            <p className="titreacc">INFORMATION SUR L'EDITEUR</p>
                        </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="0">
                        <Card.Body> */}

<p className='titrepartie'>EDITOR INFORMATION</p>

<div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                    Libellequestion={"What is your latest turnover?"}
                                    nombredebouton={6}
                                    Nbsitemmax={1}
                                    Statut1={P4Q11R1}
                                    Statut2={P4Q11R2}
                                    Statut3={P4Q11R3}
                                    Statut4={P4Q11R4}
                                    Statut5={P4Q11R5}
                                    Statut6={P4Q11R6}
                                    textproposition1={"0 to 999 KE"}
                                    setParentStatut1={setP4Q11R1}
                                    textproposition2={"1 ME to 2,99 ME"}
                                    setParentStatut2={setP4Q11R2}
                                    textproposition3={"3 ME to 4,99 ME" }
                                    setParentStatut3={setP4Q11R3}
                                    textproposition4={"5 ME to 9,99 ME"}
                                    setParentStatut4={setP4Q11R4}
                                    textproposition5={"10 ME to 19,99 ME"}
                                    setParentStatut5={setP4Q11R5}
                                    textproposition6={"More than 20 ME"}
                                    setParentStatut6={setP4Q11R6}
                                    />            
                            </div>                            
                        </div>

                        <div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                    Libellequestion={"What is your latest EBITDA?"}
                                    nombredebouton={6}
                                    Nbsitemmax={1}
                                    Statut1={P4Q12R1}
                                    Statut2={P4Q12R2}
                                    Statut3={P4Q12R3}
                                    Statut4={P4Q12R4}
                                    Statut5={P4Q12R5}
                                    Statut6={P4Q12R6}
                                    textproposition1={"Negative to 999 KE"}
                                    setParentStatut1={setP4Q12R1}
                                    textproposition2={"1 ME to 2,99 ME"}
                                    setParentStatut2={setP4Q12R2}
                                    textproposition3={"3 ME to 4,99 ME" }
                                    setParentStatut3={setP4Q12R3}
                                    textproposition4={"5 ME to 9,99 ME"}
                                    setParentStatut4={setP4Q12R4}
                                    textproposition5={"10 ME to 19,99 ME"}
                                    setParentStatut5={setP4Q12R5}
                                    textproposition6={"More than 20 ME"}
                                    setParentStatut6={setP4Q12R6}
                                    />            
                            </div>                            
                        </div>


<div className="gauchesection">
                            <div className="gauche100">
                            <Question
                                Libellequestion={"Fundraising status?" }
                                nombredebouton={4}
                                Nbsitemmax={1}
                                Statut1={P4Q0R1}
                                Statut2={P4Q0R2}
                                Statut3={P4Q0R3}
                                Statut4={P4Q0R4}
                                textproposition1={"No funds raised" }
                                setParentStatut1={setP4Q0R1}
                                textproposition2={"YES: less 1.5 million Euros or equivalent" }
                                setParentStatut2={setP4Q0R2}
                                textproposition3={"YES: between 1.5 and 5 million Euros or equivalent" }
                                setParentStatut3={setP4Q0R3}
                                textproposition4={"YES: more than 5 million Euros or equivalent" }
                                setParentStatut4={setP4Q0R4}
                                />
                            </div>                            
                        </div>


                        <div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                Libellequestion={"Presence of a doctor who has stocks in the company of the solution (one answer or more):" }
                                nombredebouton={9}
                                Nbsitemmax={9}
                                Statut1={P4Q2R1}
                                Statut2={P4Q2R2}
                                Statut3={P4Q2R3}
                                Statut4={P4Q2R4}
                                Statut5={P4Q2R5}
                                Statut6={P4Q2R6}
                                Statut7={P4Q2R7}
                                Statut8={P4Q2R8}
                                Statut9={P4Q2R9}
                                textproposition1={"Two or more physician are founders or co-founders and each holds at least 25% of the shares, and they are physician in the specialty of the solution or in e-health." }
                                setParentStatut1={setP4Q2R1}
                                textproposition2={"One physician is founder or co-founder and holds at least 25% of the shares, and is physician in the specialty of the solution or in e-health." }
                                setParentStatut2={setP4Q2R2}
                                textproposition3={"Two or more physician holds 25% or less of the shares, and they are physician in the specialty of the solution." }
                                setParentStatut3={setP4Q2R3}
                                textproposition4={"One physician holds 25% or less of the shares, and is physician in the specialty of the solution." }
                                setParentStatut4={setP4Q2R4}
                                textproposition5={"Two or more physician holds 25% or less of the shares, and are e-health experts" }
                                setParentStatut5={setP4Q2R5}
                                textproposition6={"One physician holds 25% or less of the shares, and is an e-health expert" }
                                setParentStatut6={setP4Q2R6}
                                textproposition7={"Two or more physician holds 25% or less of the shares, and is an non-health expert and non-expert in the field" }
                                setParentStatut7={setP4Q2R7}
                                textproposition8={"One physician holds 25% or less of the shares, and is an non-health expert and non-expert in the field" }
                                setParentStatut8={setP4Q2R8}
                                textproposition9={"No physician has stocks in the company" }
                                setParentStatut9={setP4Q2R9}
                                />        
                            </div>
                        </div>

                        <div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                Libellequestion={"Presence of a medical direction by a physician? (only one answer)" }
                                nombredebouton={3}
                                Nbsitemmax={1}
                                Statut3={P4Q3R1}
                                Statut2={P4Q3R2}
                                Statut1={P4Q3R3}
                                textproposition3={"NO: not medical direction by a physician" }
                                setParentStatut3={setP4Q3R1}
                                textproposition2={"YES: medical management by a medical doctor not specialist of the field" }
                                setParentStatut2={setP4Q3R2}
                                textproposition1={"YES: medical direction by a medical doctor specialist in the field of application" }
                                setParentStatut1={setP4Q3R3}
                                />        
                            </div>
                        </div>

                        <div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                Libellequestion={"Which of the following profiles are including in your advisory board?" }
                                nombredebouton={7}
                                Nbsitemmax={7}
                                Statut1={P4Q4R1}
                                Statut2={P4Q4R2}
                                Statut3={P4Q4R3}
                                Statut4={P4Q4R4}
                                Statut5={P4Q4R5}
                                Statut6={P4Q4R6}
                                Statut7={P4Q4R7}
                                textproposition1={"E-health experts: 2 or more" }
                                setParentStatut1={setP4Q4R1}
                                textproposition2={"E-health expert: only 1" }
                                setParentStatut2={setP4Q4R2}
                                textproposition3={"Medical specialty experts: 2 or more" }
                                setParentStatut3={setP4Q4R3}
                                textproposition4={"Medical specialty experts: only 1" }
                                setParentStatut4={setP4Q4R4}
                                textproposition5={"Physicians with no specialty: 2 or more" }
                                setParentStatut5={setP4Q4R5}
                                textproposition6={"Physicians with no specialty: 1 only" }
                                setParentStatut6={setP4Q4R6}
                                textproposition7={"No physician" }
                                setParentStatut7={setP4Q4R7}
                                />        
                            </div>
                        </div>

                        <div className="gauchesection">
                            <div className="gauche100">
                            <Boutonexcluinput
                                titre={"Provide the number of articles that have appeared in the media about your solution, in past 12 months (not produced by your blog or website). Max 30" }
                                modeactivation={false}
                                nombredebouton={0}
                                variable={P4Q5Rinput}
                                setParentvariable={setP4Q5Rinput}
                                reclicbouton={""}
                                placeholderinputtext={"enter a number" }
                                typeinput={"number"}
                                />
                            </div>
                        </div>

                        <div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                Libellequestion={"Has your company produced other eHealth solutions with 500 users or more?" }
                                nombredebouton={4}
                                Nbsitemmax={1}
                                Statut2={P4Q6R1}
                                Statut3={P4Q6R2}
                                Statut4={P4Q6R3}
                                Statut1={P4Q6R4}
                                textproposition2={"YES: three or more" }
                                setParentStatut2={setP4Q6R1}
                                textproposition3={"YES: two" }
                                setParentStatut3={setP4Q6R2}
                                textproposition4={"YES: one" }
                                setParentStatut4={setP4Q6R3}
                                textproposition1={"NONE" }
                                setParentStatut1={setP4Q6R4}
                                />        
                            </div>
                        </div>

                        <div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                Libellequestion={"Is your company ISO certified?" }
                                nombredebouton={2}
                                Nbsitemmax={1}
                                Statut1={P4Q7R1}
                                Statut2={P4Q7R2}
                                textproposition1={"YES" }
                                setParentStatut1={setP4Q7R1}
                                textproposition2={"NO" }
                                setParentStatut2={setP4Q7R2}
                                />        
                            </div>
                        </div>


                        <div className="gauchesection">
                            <div className="gauche100">
                                <Question
                                Libellequestion={"Wish to be reimbursed in the business model? (only one answer)" }
                                nombredebouton={3}
                                Nbsitemmax={1}
                                Statut1={P4Q9R1}
                                Statut2={P4Q9R2}
                                Statut3={P4Q9R3}
                                textproposition1={"YES" }
                                setParentStatut1={setP4Q9R1}
                                textproposition2={"NO: no need in the business model (sale of data, user subscription, etc.)" }
                                setParentStatut2={setP4Q9R2}
                                textproposition3={"Solution already reimbursed in a country" }
                                setParentStatut3={setP4Q9R3}
                                />        
                            </div>
                        </div>

                        <div className="gauchesection">
                            <div className="gauche100">
                            {P4Q9R1==1 ? <p className="titrebouton">Calculated repayment probability: {P4Q10texteTraduit}</p> : null}
                            </div>
                        </div>

                        <div className="gauchesectionfinal">
                            <div className="gauche100">
                                <button className="btn btn-danger" onClick={() => onClickbCalculeScore()}>{"VALIDATE THE SCORE" }</button>
                            </div>
                        </div>

                       


{/* 
                        </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion> */}
            </div>  


        </div>


       


    </div>





    <div className="droite">
        <div className="droiterectangle">

        {/* <span className='logoinesmobile'><img src={Logo} width="131" height="80" /></span> */}

            <div className="score">


            <div className='nomscore'>
            {P1Q1R1==0 ? "International Prescreening Score for the Simplified Evaluation of the Clinical Quality and Relevance of eHealth Apps" : null}
            {P1Q1R1==1 ? "Score is not relevant for wellness solutions" : null}
            </div>

            <div className='nomssolution'>
            {P0nomsolutionaff}
            </div>


                <div className={P1Q1R1==0 ? 'scoreinfo' : 'scorehiden'}>

                    <div className='scoregauche'>

                    

                        <div className='infoappli'>
                            <span className='textescore'>{"Application Information" }</span> <br/>
                            <span className='score20'>{ModeGratuit==true ? Pointsur20Partie1aff : Pointsur20Partie1} /20 </span>
                            <span className='lettre'>
                            {Lettreinfo=="E" ? <img src={LE} width="40" height="30" /> : null}
                            {Lettreinfo=="D" ? <img src={LD} width="40" height="30" /> : null}
                            {Lettreinfo=="C" ? <img src={LC} width="40" height="30" /> : null}
                            {Lettreinfo=="B" ? <img src={LB} width="40" height="30" /> : null}
                            {Lettreinfo=="A" ? <img src={LA} width="40" height="30" /> : null}
                            </span>
                        </div>



                        <div className='infoeval'>
                        <span className='textescore'>{"Clinical assessment" }</span> <br/>
                        <span className='score20'>{ModeGratuit==true ? Pointsur20Partie3aff : Pointsur20Partie3} /20 </span>
                        <span className='lettre'>
                            {Lettreclinique=="E" ? <img src={LE} width="40" height="30" /> : null}
                            {Lettreclinique=="D" ? <img src={LD} width="40" height="30" /> : null}
                            {Lettreclinique=="C" ? <img src={LC} width="40" height="30" /> : null}
                            {Lettreclinique=="B" ? <img src={LB} width="40" height="30" /> : null}
                            {Lettreclinique=="A" ? <img src={LA} width="40" height="30" /> : null}
                            </span>
                        </div>


                    </div>

                    <div className='scoredroite'>

                    <div className='infocible'>
                    <span className='textescore'>{"Target assessment" }</span>  <br/>
                    <span className='score20'>{ModeGratuit==true ? Pointsur20Partie2aff : Pointsur20Partie2} /20 </span>
                    <span className='lettre'>
                            {Lettrecible=="E" ? <img src={LE} width="40" height="30" /> : null}
                            {Lettrecible=="D" ? <img src={LD} width="40" height="30" /> : null}
                            {Lettrecible=="C" ? <img src={LC} width="40" height="30" /> : null}
                            {Lettrecible=="B" ? <img src={LB} width="40" height="30" /> : null}
                            {Lettrecible=="A" ? <img src={LA} width="40" height="30" /> : null}
                            </span>      
                        </div>

                        <div className='infoediteur'>
                        <span className='textescore'>{"Editor Rating" }</span>  <br/>
                        <span className='score20'>{ModeGratuit==true ? Pointsur20Partie4aff : Pointsur20Partie4} /20 </span>
                        <span className='lettre'>
                            {Lettreediteur=="E" ? <img src={LE} width="40" height="30" /> : null}
                            {Lettreediteur=="D" ? <img src={LD} width="40" height="30" /> : null}
                            {Lettreediteur=="C" ? <img src={LC} width="40" height="30" /> : null}
                            {Lettreediteur=="B" ? <img src={LB} width="40" height="30" /> : null}
                            {Lettreediteur=="A" ? <img src={LA} width="40" height="30" /> : null}
                            </span>
                        </div>


                    </div>

                    </div>

                    <div className={P1Q1R1==0 ? 'scoretotal' : 'scorehiden'}>

                    {Eliminatoireaff===1 ? <span className='texteeliminatoire'>ITEM ELIMINATOIRE - score non calculé</span> : null}


                    {/* FENETRE ITEM ELIMINATOIRE */}
                    {/* <div className='popup' style={{display : Displayaff, float:"left"}}>
                        <Popup trigger={<button className="btn btn-outline-danger"> Détails</button>} modal>
                            <div>
                            Item(s) séléctionné(s) éliminatoire(s)  : 
                            {P1Q1R1==1 ? <br/> : null }
                            {P1Q1R1==1 ? <br/> : null }
                            {P1Q1R1==1 ? "Question : Domaine de l'application :" : null }
                            {P1Q1R1==1 ? <br/> : null }
                            {P1Q1R1==1 ? "- Domaine du bien être " : null }

                            {P1Q4R5==1 ? <br/> : null }
                            {P1Q4R5==1 ? <br/> : null }
                            {P1Q4R5==1 ? "Question : Quel est le type d'algorithme de la solution ?" : null }
                            {P1Q4R5==1 ? <br/> : null }
                            {P1Q4R5==1 ? "- Algorithme de plus de 5 ans non réévalué avec les nouveaux standards  de prise en charge (analyse de risque)" : null }

                            {P2Q4R4==1 ? <br/> : null }
                            {P2Q4R4==1 ? <br/> : null }
                            {P2Q4R4==1 ? "Question : Co-développement avec association de patients ou des patients :" : null }
                            {P2Q4R4==1 ? <br/> : null }
                            {P2Q4R4==1 ? "- Pas de patients impliqués dans le développement" : null }

                            {(P3Q2R1==1|P3Q2R2==1) ? <br/> : null }
                            {(P3Q2R1==1|P3Q2R2==1) ? <br/> : null }
                            {(P3Q2R1==1|P3Q2R2==1) ? "Question : Présence d'un avis de 1 à 2 médecins spécialistes sur la pertinence clinique théorique de la solution ? :" : null }
                            {(P3Q2R1==1|P3Q2R2==1) ? <br/> : null }
                            {(P3Q2R1==1) ? "- Pas d'avis pris" : null }
                            {(P3Q2R2==1) ? "- Pertinence faible" : null }

                            {(P3Q4R8==1) ? <br/> : null }
                            {(P3Q4R8==1) ? <br/> : null }
                            {(P3Q4R8==1) ? "Question : Quel est le niveau de preuve actuel de l'outil/algorithme/questionnaires :" : null }
                            {(P3Q4R8==1) ? <br/> : null }
                            {(P3Q4R8==1) ? "- Aucune" : null }

                            {(P4Q3R1==1) ? <br/> : null }
                            {(P4Q3R1==1) ? <br/> : null }
                            {(P4Q3R1==1) ? "Question : Présence d'une direction médicale ?" : null }
                            {(P4Q3R1==1) ? <br/> : null }
                            {(P4Q3R1==1) ? "- NON : pas de direction médicale" : null }

                            {(P4Q4R7==1) ? <br/> : null }
                            {(P4Q4R7==1) ? <br/> : null }
                            {(P4Q4R7==1) ? "Question : Composition du board médical et scientifique :" : null }
                            {(P4Q4R7==1) ? <br/> : null }
                            {(P4Q4R7==1) ? "- Pas de médecin" : null }

                            {(P4Q8R1==1) ? <br/> : null }
                            {(P4Q8R1==1) ? <br/> : null }
                            {(P4Q8R1==1) ? "Question : Evaluation de la sécurité de l'éditeur :" : null }
                            {(P4Q8R1==1) ? <br/> : null }
                            {(P4Q8R1==1) ? "- Alerte de sécurité ANSM avec perte de chance" : null }


                            </div>
                        </Popup>

                        </div> */}



                    {Eliminatoireaff===1 ? null :<span className='textescoretotal'>{"TOTAL SCORE" }</span>}

                    <div className='chiffrescoretotale'>
                    <span className='score20tot'>{ModeGratuit==true ? Pointsur20Totalaff : Pointsur20Total}/20</span>
                    <span className='lettreG'>
                            {Lettregenerale=="E" ? <img src={LE} width="67" height="51" /> : null}
                            {Lettregenerale=="D" ? <img src={LD} width="67" height="51" /> : null}
                            {Lettregenerale=="C" ? <img src={LC} width="67" height="51" /> : null}
                            {Lettregenerale=="B" ? <img src={LB} width="67" height="51" /> : null}
                            {Lettregenerale=="A" ? <img src={LA} width="67" height="51" /> : null}
                            </span>
                    <br/>
                    {/* <span className='texteposition'>{"Positioning of the solution" } : </span> <span className='texteposition'>{ModeGratuit==true ? Infopositionscoreaff : Infopositionscore}</span> <br/> */}
                    </div>

                                                                {/* FENETRE ITEM NEGATIF */}
                                                                

                    
                    </div>





            </div>

            <div className='souscadre'>
                <div className='textereference'><span className='textereferenceT'>Quintile scale - ]8 : E,   [8-10[ : D,   [10-13[ : C,   [13-15[ : B,   [15: A</span></div>
                <div className='textereference'><span><a className='textereferenceT' href="https://pubmed.ncbi.nlm.nih.gov/35788102/">Wagneur et al, JMIR 2022</a></span></div>
            </div>

            <div className='popup' style={{display : Displaynegatif, float:"left", marginTop:"3px"}}>
                        <Popup trigger={<button className="btn btn-outline-danger"> {"List of your items deducting points" } </button>} modal>
                            <div>
                            {"Selected item(s) deducting points:" }
                            {P1Q1R1==1 ? <br/> : null }
                            {P1Q1R1==1 ? <br/> : null }
                            {P1Q1R1==1 ? <span>{"Question: Field of application:" }</span> : null }
                            {P1Q1R1==1 ? <br/> : null }
                            {P1Q1R1==1 ? <span>{"- Area of well-being" }</span> : null }

                            {P1Q4bR1==1 ? <br/> : null }
                            {P1Q4bR1==1 ? <br/> : null }
                            {P1Q4bR1==1 ? <span>{"Question: What is the type of algorithm of the solution?" }</span> : null }
                            {P1Q4bR1==1 ? <br/> : null }
                            {P1Q4bR1==1 ? <span>{"- Algorithm more than 5 years old not reassessed with the new standards of care (risk analysis)" }</span> : null }

                            {P2Q4R4==1 ? <br/> : null }
                            {P2Q4R4==1 ? <br/> : null }
                            {P2Q4R4==1 ? <span>{"Question: Co-development with patient association or patients:" }</span> : null }
                            {P2Q4R4==1 ? <br/> : null }
                            {P2Q4R4==1 ? <span>{"- No patients involved in the development for software intended for patients" }</span> : null }

                            {(P3Q2R1==1|P3Q2R2==1) ? <br/> : null }
                            {(P3Q2R1==1|P3Q2R2==1) ? <br/> : null }
                            {(P3Q2R1==1|P3Q2R2==1) ? <span>{"Question: Presence of an opinion from 1 to 2 medical specialists on the theoretical clinical relevance of the solution? :" }</span> : null }
                            {(P3Q2R1==1|P3Q2R2==1) ? <br/> : null }
                            {(P3Q2R1==1) ? <span>{"- No opinion taken" }</span> : null }
                            {(P3Q2R2==1) ? <span>{"- Low relevance" }</span> : null }

                            {(P3Q4R8==1) ? <br/> : null }
                            {(P3Q4R8==1) ? <br/> : null }
                            {(P3Q4R8==1) ? <span>{"Question: What is the current level of evidence of the tool/algorithm/questionnaires:" }</span> : null }
                            {(P3Q4R8==1) ? <br/> : null }
                            {(P3Q4R8==1) ? <span>{"- None" }</span> : null }

                            {(P4Q3R1==1) ? <br/> : null }
                            {(P4Q3R1==1) ? <br/> : null }
                            {(P4Q3R1==1) ? <span>{"Question: Presence of a medical direction?" }</span> : null }
                            {(P4Q3R1==1) ? <br/> : null }
                            {(P4Q3R1==1) ? <span>{"- NO: no medical direction" }</span> : null }

                            {(P4Q4R7==1) ? <br/> : null }
                            {(P4Q4R7==1) ? <br/> : null }
                            {(P4Q4R7==1) ? <span>{"Question: Composition of the medical and scientific board:" }</span> : null }
                            {(P4Q4R7==1) ? <br/> : null }
                            {(P4Q4R7==1) ? <span>{ "- No doctor" }</span> : null }

                            {(P4Q8R1==1) ? <br/> : null }
                            {(P4Q8R1==1) ? <br/> : null }
                            {(P4Q8R1==1) ? <span>{"Question: Publisher Security Rating:" }</span> : null }
                            {(P4Q8R1==1) ? <br/> : null }
                            {(P4Q8R1==1) ? <span>{"- ANSM security alert with loss of chance" }</span> : null }

                            {(P1Q4R3==1 & (P1Q4c1R1==0 & P1Q4c2R1==0)) ? <br/> : null }
                            {(P1Q4R3==1 & (P1Q4c1R1==0 & P1Q4c2R1==0)) ? <br/> : null }
                            {(P1Q4R3==1 & (P1Q4c1R1==0 & P1Q4c2R1==0)) ? <span>{"Question: What is the type of algorithm of the solution?" }</span> : null }
                            {(P1Q4R3==1 & (P1Q4c1R1==0 & P1Q4c2R1==0)) ? <br/> : null }
                            {(P1Q4R3==1 & (P1Q4c1R1==0 & P1Q4c2R1==0)) ? <span>{"- Unintelligible AI with sensitivity <75% and non-visibility of interpretability elements influencing decision-making" }</span> : null }

                            


                            </div>
                        </Popup>

                        </div>




        </div>




    </div>

</div>
</div>
)
}

export default Pageint
